import React, {
  useState,
  Fragment,
  useMemo,
  useRef,
  useEffect,
  useCallback,
} from "react";
import { useSelector, useDispatch } from "react-redux";

import { useNavigate, useLocation } from "react-router-dom";
import Toastr from "../../components/common/Toastr";
import { ToastContainer } from "react-toastify";
import Select from "react-select";
import { Button, Modal } from "react-bootstrap";
import { useReactToPrint } from "react-to-print";

import PageTitle from "../../layouts/PageTitle";
import OrderTable from "../../components/table/ReactTable/OrderTable";
import RowSelectTable from "../../components/table/ReactTable/RowSelectTable";

import CommonService from "../../../services/Common/CommonService";
import { ColumnFilter } from "../../components/table/ReactTable/ColumnFilter";

import generatePDF from "../../components/export/generatePDF";
import packingSlipPDF from "../../components/export/packingSlipPDF";
import generateXlsx from "../../components/export/generateXlsx";
import { masterActions, orderActions, userActions } from "../../../_store";
import useFullPageLoader from "../../../hooks/useFullPageLoader";
import { fCurrency } from "../../../utils/formatNumber";
import emptyImage from "../../../images/no-image-png-2.png";
import {
  restApi,
  restApi_PD,
} from "../../../services/wooCommerceRestApi/restApi";
import { encryptData } from "../../../utils/encryptDecrypt";

const { REACT_APP_API_IMAGE_URL } = process.env;

const clearSession = () => {
  if (localStorage.getItem("filterValues")) {
    localStorage.removeItem("filterValues");
  }
};

const OrderList = () => {
  const dispatch = useDispatch();
  let navigate = useNavigate();
  const [loader, showLoader, hideLoader] = useFullPageLoader();

  // #region ------------------  Reducer --------------------------------
  // Authentication Selector
  const currentUser = useSelector((x) => x.auth.user);
  const settingResponse = useSelector((x) => x.users.settingResponse);

  // Order Data Selectors
  const {
    isLoading,
    orderSaveResponse,
    orderPreparationResponse,
    orderCourierDetails,
    orderResponse,
    orderCancelResponse,
    orderAssignResponse,
    orderCourierResponse,
    orderList,
    prepperDrpList,
    dispatcherDrpList,
    skidBreakdownDetailsList,
    enumOrderStatus,
    dispatchDetailsResponse,
    orderPaymentTransactionResponse,
    orderDetail,
    skidBreakdownDetails,
  } = useSelector((state) => state.order);

  console.log("orderList:",orderList)
  debugger;
  // Master Data Selectors
  const {
    orderStatusDrpList,
    warehouseDrpList,
    boxNumberDrpList,
    courierTypeDrpList,
    paymentTypeDrpList,
  } = useSelector((state) => state.master);

  // #endregion ------------------  Reducer End --------------------------------

  // #region ------------------  use State --------------------------------
  const inputRef = useRef(null);
  const typeOrderProductModelRef = useRef([]);
  const orderCurrentRow = useRef({});

  const [isPaymentModal, setPaymentModal] = useState(false);
  const [isLabelModal, setLabelModal] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [isOrderAssignModal, setOrderAssignModal] = useState(false);
  const [isOpenModal, setOpenModal] = useState(false);
  const [isCancelModal, setCancelModal] = useState(false);
  const [isCourierModal, setCourierModal] = useState(false);
  const [isordervalues, setisordervalues] = useState(false);
  const [isorderLable, setisorderLable] = useState(false);
  const [isPrintData, setisPrintData] = useState(false);
  const [isSkidBreakdownModal, setSkidBreakdownModal] = useState(false);
  const [isdisabled, setIsDisabled] = useState(false);
  const [selectedRows, setSelectedRows] = useState([]);

  const [OrderNo, setOrderNo] = useState(0);

  const [ClientName, setClientName] = useState(0);

  const [courierModalDetails, setCourierModalDetails] = useState({});

  const [orderStatusList, setOrderStatusList] = useState([]);
  const [optionSelected, setSelected] = useState([]);
  const [OrderSelected, setOrderSelected] = useState([]);
  const [ColumnOrderdata, setColumnOrderData] = useState([]);

  const [isOrderReversedModal, setOrderReversedModal] = useState(false);
  // const [filterValues, setFilterValues] = useState([]);

  const [viewFilter, setviewFilter] = useState([]);

  const [finalTableData, setFinalTableData] = useState([]);

  const handleTableDataUpdate = useCallback((data) => {
    setFinalTableData(data);
  }, []);

// ===== START ADMIN CANCEL CHANGES =====
const [isRevealPwd, setIsRevealPwd] = useState(false);

const [cancelAuthorization, setCancelAuthorization] = useState({
    isAdminPasscodeValid: false,
    AdminPasscode: "",
    CancelledReason: "",
});

const [selectedCancelOrder, setSelectedCancelOrder] = useState(null);
// ===== END ADMIN CANCEL CHANGES =====

  //Add data
  const [addFormData, setAddFormData] = useState({
    OrderStatusID: 0,
    WareHouseID: 0,
    OrderID: 0,
    OrderNumber: 0,
    ClientID: 0,
    AssignedDispatcherID: 0,
    OrderStatusOptions: null,
    OrderStatus: "",
    CancelledReason: "",
    CancelledBy: currentUser.Id,
    UpdatedBy: currentUser.Id,
    WarehouseOption: null,
    IsPartyDeco: false,
    CancelPasscode :"",
  });

  // Assign Model
  const [orderAssignData, SetOrderAssignData] = useState({
    OrderID: 0,
    OrderNumber: 0,
    WareHouseID: 0,
    AssignedPrepperID: 0,
    AssignedDispatcherID: 0,
    PrepperOption: null,
    DispatcherOption: null,
    WarehouseAssignOption: null,
    OrderStatusID: 0,
    Status: 1,
    CreatedBy: currentUser.Id,
    ClientID: 0,
    IsPartyDeco: false,
  });
  //payment Data model
  const [addPaymentData, SetPaymentData] = useState({
    PaymentID: 0,
    OrderID: 0,
    OrderNumber: 0,
    PaymentAmount: 0,
    PaymentTypeID: 0,
    PaymentStatusID: 1,
    CheckNumber: "",
    ImageFilePath: "",
    ImageBase64: "",
    GrandTotal: "",
    Box: "",
    PaymentStatusOption: { value: 1, label: "Paid" },
    PaymentTypeOption: { value: 8, label: "QB" },
    IsNoPayment: false,
    Status: 1,
    CreatedBy: currentUser.Id,
    ClientName: "",
    IsPartyDeco: false,
  });

  const [courierDetails, setCourierDetails] = useState({
    AdminCourierTypeID: 0,
    AdminBillFilePath: "",
    ImageBase64: "",
    OrderNumber: 0,
    OrderID: 0,
    AssignedDispatcherID: 0,
    ClientID: 0,
    CreatedBy: currentUser.Id,
    IsPartyDeco: false,
    IsSkipBOL: 0,
  });

  // Skid Breakdown
  const [skidBreakdown, setSkidBreakdown] = useState({
    OrderID: 0,
    TotalSkidWeight: 0,
    CreatedBy: currentUser.Id,
    TypeOrderSkidBreakdownModel: [],
    IsOrderSkidBreakdown: false,
    IsOrderSkid: false,
  });

  const [skidBreakdownList, setSkidBreakdownList] = useState([
    {
      OrderSkidBreakdownID: 0,
      SkidWeight: "",
      SkidDimensionLength: "",
      SkidDimensionWeight: "",
      SkidDimensionHeight: "",
      ImageBase64: "",
      ImageFilePath: "",
      SkidIndex: 1,
      SkidBoxNumbers: 0,
    },
  ]);

  let styles = {
    control: (styles) => ({ ...styles, border: "1px solid red" }),
  };

  // #endregion ------------------  use State End --------------------------------

  const newFormData = { ...addFormData };

  const skidBreakdownListData = [...skidBreakdownList];

  // #region ------------------ Grid columns AND Pdf --------------------------------

  const columns_Order = [
    {
      Header: "Order ID",
      Footer: "Order ID",
      accessor: "OrderNumber",
      justify: "center",
      Filter: ColumnFilter,
    },
    {
      Header: "Client",
      Footer: "Client",
      accessor: "ClientName",
      justify: "left",
      Filter: ColumnFilter,
    },

    {
      Header: "Order Source",
      Footer: "Order Source",
      accessor: "OrderSource",
      justify: "left",
      Filter: ColumnFilter,
    },
    {
      Header: "Website",
      Footer: "Website",
      accessor: "Woocommerce",
      justify: "left",
      Filter: ColumnFilter,
    },
    {
      Header: "Order Status",
      Footer: "Order Status",
      accessor: "OrderStatus",
      justify: "left",
      Filter: ColumnFilter,
    },
    {
      Header: "Order Date",
      Footer: "Order Date",
      accessor: "CreatedDateString",
      justify: "left",
      Filter: ColumnFilter,
    },
    {
      Header: "Grand Total",
      Footer: "Grand Total",
      accessor: "GrandTotalStr",
      // Cell: ({ value }) => { return fCurrency(value) },
      justify: "right",
      Filter: ColumnFilter,
    },

    {
      Header: "",
      Footer: "",
      accessor: "ClientID",
      disableFilters: true,
      Cell: ({ row }) => {
        return (
          <>
            {currentUser.UserTypeID !== 6 && (
              <div className="d-flex">
                {(currentUser.UserTypeID === 1 ||
                  currentUser.UserTypeID === 8 ||
                  currentUser.UserTypeID === 2) &&
                  row.original.OrderStatusID !== 8 && (
                    <>
                      {row.original.OrderStatusID < 5 &&
                        currentUser.UserTypeID !== 8 &&
                        row.original.IsQuickBook === false && (
                          <div
                            onClick={() => handleEditClick(row.original)}
                            title="Edit"
                            style={{ background: "#2858a5", border: "#2858a5" }}
                            className="btn btn-primary shadow btn-xs sharp me-1"
                          >
                            <i className="fa fa-pencil-alt"></i>
                          </div>
                        )}
                      {row.original.IsAPIError === false &&
                        row.original.IsOrderCreated === true && (
                          <div
                            onClick={() => handleOrderAssign(row.original)}
                            title="Order Allocation"
                            className=" green-btn-1 shadow btn-xs sharp me-1"
                          >
                            <i className="fas fa-cart-arrow-down"></i>
                          </div>
                        )}
                    </>
                  )}
                {currentUser.UserTypeID === 3 &&
                  row.original.OrderStatusID === 2 &&
                  row.original.IsOrderPrepared !== true && (
                    <div
                      onClick={() => handleOrderPreparation(row.original)}
                      title="Order Preparation"
                      style={{ background: "#00b5e5", border: "#00b5e5" }}
                      className="btn btn-secondary shadow btn-xs sharp me-1"
                    >
                      <i className="fas fa-balance-scale"></i>
                    </div>
                  )}

                <div
                  onClick={() => handleViewOrder(row.original)}
                  title="View Order"
                  style={{ background: "#e50a7e", border: "#e50a7e" }}
                  className="btn btn-secondary shadow btn-xs sharp me-1"
                >
                  <i className="fa fa-eye"></i>
                </div>

                {((row.original.OrderStatusID < 3 &&
                  (currentUser.UserTypeID === 1 ||
                    currentUser.UserTypeID === 2) &&
                  row.original.OrderStatusID !== 1) ||
                  (row.original.OrderStatusID === 3 &&
                    row.original.IsQuickBook === true &&
                    row.original?.AdminCourierTypeID > 0 &&
                    row.original?.IsOrderSkidBreakdown === true &&
                    (currentUser.UserTypeID === 1 ||
                      currentUser.UserTypeID === 2) &&
                    row.original.OrderStatusID !== 1) ||
                  (currentUser.UserTypeID === 3 &&
                    row.original.OrderStatusID === 2 &&
                    row.original.IsOrderPrepared === true) ||
                  (currentUser.UserTypeID === 4 &&
                    row.original.OrderStatusID === 5)) &&
                  row.original.OrderStatusID !== 8 && (
                    <div
                      onClick={() => changeOrderStatus(row.original)}
                      title=" Change Order Status"
                      className="btn default-blue-color shadow btn-xs sharp me-1"
                    >
                      <i className="fa fa-sync"></i>
                    </div>
                  )}

                {(currentUser.UserTypeID === 1 ||
                  currentUser.UserTypeID === 2) &&
                  row.original.OrderStatusID === 4 && (
                    <div
                      onClick={() => changePaymentStatus(row.original)}
                      title="Payment Transaction"
                      style={{ background: "#00b5e5", border: "#00b5e5" }}
                      className="btn btn-success shadow btn-xs sharp me-1"
                    >
                      <i className="fa fa-credit-card"></i>
                    </div>
                  )}
                {
                  row.original.OrderStatusID >= 6 &&
                    (((currentUser.UserTypeID === 1 ||
                      currentUser.UserTypeID === 2) &&
                      row.original.OrderStatusID === 7) ||
                      (row.original.OrderStatusID !== 8 &&
                        currentUser.UserTypeID === 4 &&
                        row.original.OrderStatusID !== 7) ||
                      (currentUser.UserTypeID === 4 &&
                        row.original.OrderStatusID === 7)) && (
                      // {currentUser.UserTypeID === 4 &&
                      //     (row.original.OrderStatusID === 6 || row.original.OrderStatusID === 7) && (
                      <div
                        onClick={() => dispatchdetails(row.original)}
                        // title= {" Dispatch Details "}
                        title={
                          row.original && row.original.OrderStatusID !== 7
                            ? " Add Dispatch Details "
                            : "View Dispatch Details "
                        }
                        style={{ background: "#8abd24", border: "#8abd24" }}
                        // className="btn btn-success shadow btn-xs sharp me-1"
                        className={
                          row.original.OrderStatusID !== 7
                            ? "btn-primary-color-Dispatch shadow btn-xs sharp me-1"
                            : "btn-danger-color-Dispatch shadow btn-xs sharp me-1"
                        }
                      >
                        <i className="fa fa-solid fa-shipping-fast"></i>
                      </div>
                    )
                  //)
                }
                {row.original.OrderStatusID >= 3 &&
                  row.original.OrderStatusID !== 8 && (
                    <div
                      title="Packing Slip "
                      onClick={() => handlePackingSlipPDF(row.original)}
                      className="btn shadow btn-xs sharp me-1"
                      style={{ background: "#ED8B00", border: "#ED8B00" }}
                    >
                      <i
                        className="far fa-file-pdf"
                        style={{ color: "white" }}
                      ></i>
                    </div>
                  )}

                {row.original.OrderStatusID >= 3 &&
                  row.original.OrderStatusID !== 8 && (
                    <div
                      title="Label Print"
                      onClick={() => handlePrint(row.original)}
                      className="btn shadow btn-xs sharp me-1"
                      style={{ background: "#63B1BC", border: "#63B1BC" }}
                    >
                      <i
                        className="fas fa-print"
                        style={{ color: "white" }}
                      ></i>
                    </div>
                  )}

                {(currentUser?.UserTypeID === 1 ||
                  currentUser?.UserTypeID === 2) &&
                  row.original.OrderStatusID >= 3 &&
                  row.original.OrderStatusID !== 8 && (
                    <div
                      onClick={() => handleCourierDetails(row.original)}
                      title="Order Courier Details"
                      className={
                        row.original.OrderStatusID > 3
                          ? "btn grey-btn-color shadow btn-xs sharp me-1"
                          : "shadow btn-xs sharp me-1 cursor-pointer"
                      }
                      style={{
                        backgroundColor: "#d14e1bd1",
                        color: "#fff",
                      }}
                    >
                      <i className="fas fa-dolly-flatbed"></i>
                    </div>
                  )}

                {/* {(currentUser.UserTypeID === 1 ||
                  currentUser.UserTypeID === 2) &&
                  row.original.OrderStatusID !== 8 &&
                  row.original.OrderStatusID < 5 && (
                    <div
                      onClick={() => handleCancelOrder(row.original)}
                      title="Cancel"
                      className="btn btn-danger-color shadow btn-xs sharp me-1"
                    >
                      <i className="fa fa-times"></i>
                    </div>
                  )} */}


{(currentUser.UserTypeID === 1 ||
  currentUser.UserTypeID === 2) &&
  row.original.OrderStatusID !== 8 && (
    <div
      onClick={() => onSubmitAdminPasscodeVerify(row.original)}
      title="Cancel"
      className="btn btn-danger-color shadow btn-xs sharp me-1"
    >
      <i className="fa fa-times"></i>
    </div>
  )}



                {row.original.OrderStatusID >= 3 &&
                  (((currentUser.UserTypeID === 1 ||
                    currentUser.UserTypeID === 2) &&
                    row.original.IsOrderSkidBreakdown === true) ||
                    (row.original.OrderStatusID !== 8 &&
                      currentUser.UserTypeID === 4) ||
                    currentUser.UserTypeID === 3) && (
                    <div
                      onClick={() => handleOpenSkidBreakdown(row.original)}
                      title={
                        row.original &&
                        row.original.IsOrderSkidBreakdown === false
                          ? "Skid Break"
                          : "View Skid Break"
                      }
                      className={
                        row.original.IsOrderSkidBreakdown === false
                          ? "btn btn-primary-color shadow btn-xs sharp me-1"
                          : "btn grey-btn-color shadow btn-xs sharp me-1"
                      }
                    >
                      <i className="fas fa-car-crash"></i>
                    </div>
                  )}

                {row.original.OrderStatusID === 3 &&
                  (currentUser.UserTypeID === 1 ||
                    currentUser.UserTypeID === 2) &&
                  row.original.IsQuickBook === false && (
                    <div
                      onClick={() => handleOrderQuickBook(row.original)}
                      title="Add QuickBooks"
                      className="btn btn-secondary shadow btn-xs sharp me-1"
                    >
                      qb
                    </div>
                  )}

                {row.original.IsQuickBook === true && (
                  <div
                    title="QuickBooks Completed"
                    // style={{ background: "#e50a7e", border: "#e50a7e" }}
                    className="btn grey-btn-color shadow btn-xs sharp me-1"
                  >
                    qb
                  </div>
                )}
                {/* {
                  (currentUser.UserTypeID === 1 ||
                    currentUser.UserTypeID === 2)  && (
                    <div
                      onClick={() => handleOpenOrderReversed(row.original)}
                      title="Reversed"
                      className="btn btn-danger-color shadow btn-xs sharp me-1"
                    >
                      <i className="flaticon-005-back-arrow"></i>
                    </div>
                    )} */}
              </div>
            )}
          </>
        );
      },
    },
  ];

  const columns = columns_Order;

  const reversedColumns = [
    {
      Header: "Category",
      accessor: "CategoryName",
      justify: "center",
      Filter: ColumnFilter,
    },
    {
      Header: "Lot Number",
      accessor: "LotNumber",
      justify: "left",
      Filter: ColumnFilter,
    },

    {
      Header: "SKU",
      accessor: "SKU",
      justify: "left",
      Filter: ColumnFilter,
    },
    {
      Header: "Product",
      accessor: "ProductName",
      justify: "left",
      Filter: ColumnFilter,
    },
    {
      Header: "Quantity",
      accessor: "Quantity",
      justify: "left",
      Filter: ColumnFilter,
    },
    {
      Header: "Unit Price",
      accessor: "UnitPrice",
      justify: "left",
      Filter: ColumnFilter,
    },
    {
      Header: "Total",
      accessor: "Total",
      justify: "left",
      Filter: ColumnFilter,
    },
  ];

  //Pdf columns
  const generateColumns = [
    {
      header: "Order ID",
      dataKey: "OrderNumber",
      cellWidth: 22,
    },
    {
      header: "Client",
      dataKey: "ClientName",
      cellWidth: 60,
    },
    {
      header: "Order Source",
      dataKey: "OrderSource",
      cellWidth: 40,
    },
    {
      header: "Website",
      dataKey: "Woocommerce",
      cellWidth: 30,
    },
    {
      header: "Order Status",
      dataKey: "OrderStatus",
      cellWidth: 50,
    },
    {
      header: "Order Date",
      dataKey: "CreatedDateString",
      cellWidth: 30,
    },
    {
      header: "Grand Total",
      dataKey: "GrandTotalStr",
      cellWidth: 40,
    },
  ];

  const packingSlipColumns = [
    {
      header: "SNo",
      dataKey: "RowNumber",
    },
    {
      header: "Product",
      dataKey: "ProductName",
    },
    {
      header: "SKU",
      dataKey: "SKU",
    },
    {
      header: "Qty",
      dataKey: "QuantityStr",
    },
    {
      header: "Total Weight",
      dataKey: "TotalWeightStr",
    },
    {
      header: "Box Number",
      dataKey: "BoxNumber",
    },
    // {
    //     header: "Total Price",
    //     dataKey: "TotalPriceStr",
    // },
  ];

  // #endregion ------------------  Grid columns AND Pdf  End --------------------------------

  // #region ------------------ Order List Action --------------------------------

  // order Save Response Alert AND //orderList/Fetch

  useEffect(() => {
    // Show the loader to indicate processing
    showLoader();

    // Function to handle success messages based on response codes
    const handleSuccess = (response, message) => {
      if (response === 1 || response === 2) {
        // Show success message using Toastr
        Toastr(message, "success");
      }
    };

    // Display success messages for order and preparation responses
    handleSuccess(orderSaveResponse, "Order saved successfully");
    handleSuccess(
      orderPreparationResponse,
      "Order Preparation saved successfully"
    );

    const Status = 1;

    // Function to dispatch multiple actions for fetching dropdown lists and order data
    const dispatchActions = () => {
      dispatch(
        orderActions.GetOrderList({
          OrderID: 0,
          ClientID: 0,
          OrderSourceID: 0,
          Status,
          OrderStatusID: 0,
          UserID: currentUser.Id,
          UserTypeID: currentUser.UserTypeID,
        })
      );

      //dispatch(userActions.getSettingAndCheckRefreshToken());
      // Fetch order status dropdown list
      dispatch(
        masterActions.GetOrderStatusDrpList({ OrderStatusID: 0, Status })
      );
      // Fetch warehouse list
      dispatch(masterActions.GetWarehouseList({ WareHouseID: 0, Status }));
      // Fetch user dropdown list for specific user types
      dispatch(
        orderActions.GetUserDrpList({ UserTypeID1: 3, UserTypeID2: 4, Status })
      );
      // Fetch payment type dropdown list
      dispatch(
        masterActions.GetPaymentTypeDrpList({ PaymentTypeID: 0, Status })
      );
      // Fetch courier type dropdown list
      dispatch(
        masterActions.GetCourierTypeDrpList({ CourierTypeID: 0, Status })
      );
      // Fetch order list based on various filters
      // if (orderList.length === 0) {

      // }
    };

    // Call function to dispatch actions
    dispatchActions();

    // Dependencies array to re-run the effect when dispatch changes
  }, [dispatch]);

  useEffect(() => {
    if (isLoading) hideLoader();
  }, [isLoading]);

  useEffect(() => {
    if (dispatchDetailsResponse === 1) {
      dispatch(orderActions.clearOrderResponse());
      Toastr("Dispatch Details updated successfully", "success");
    }
  }, [dispatch]);

  // Add Order navigate
  const handleAddOrder = () => {
    dispatch(orderActions.clearOrderResponse());
    navigate("/AddEditOrder");
  };

  // Add Edit Order navigate
  const handleEditClick = (orderDetail) => {
    // clearSession();

    if (viewFilter.length > 0) {
      localStorage.setItem(`filterValues`, JSON.stringify(viewFilter));
    }
    const data = { OrderID: orderDetail.OrderID };

    navigate("/AddEditOrder", {
      state: data,
    });
  };

  const handleOrderPreparation = (orderDetail) => {
    if (viewFilter.length > 0) {
      localStorage.setItem(`filterValues`, JSON.stringify(viewFilter));
    }
    navigate("/OrderPreparation", {
      state: orderDetail,
    });
  };

  const handleOrderQuickBook = (orderDetail) => {
    // Show the loader to indicate processing
    showLoader();

    // Call the service to update QuickBooks with the order data
    CommonService.UpdateQuickBookData({
      UserId: currentUser.Id,
      OrderID: orderDetail.OrderID,
      ClientEmailID: orderDetail.ClientEmailID,
    })
      .then((res) => {
        // Check if the response contains data
        if (res.data) {
          // If the response output indicates success
          if (res.data.output === 1) {
            // Dispatch action to update the order list
            dispatch(
              orderActions.GetOrderList({
                OrderID: 0,
                ClientID: 0,
                OrderSourceID: 0,
                Status: 1,
                OrderStatusID: 0,
                UserID: currentUser.Id,
                UserTypeID: currentUser.UserTypeID,
              })
            );

            dispatch(userActions.tempUpdateSetting(res.data.Setting));

            // Notify user of successful addition to QuickBooks
            Toastr("Order Added Successfully in QuickBooks", "success");
          } else {
            // Notify user with the error message from response
            Toastr(res.data.errorMsg || "Error QuickBooks", "warning");

            dispatch(userActions.tempUpdateSetting(res.data.Setting));
            dispatch(
              orderActions.GetOrderList({
                OrderID: 0,
                ClientID: 0,
                OrderSourceID: 0,
                Status: 1,
                OrderStatusID: 0,
                UserID: currentUser.Id,
                UserTypeID: currentUser.UserTypeID,
              })
            );
          }
        } else {
          // Notify user of a generic error if no data is returned
          Toastr("Error QuickBooks", "warning");
        }
      })
      .catch(() => {
        // Handle any errors that occur during the service call
        Toastr(
          "Please close QuickBooks connected table. After that, try adding the order to QuickBooks.",
          "warning"
        );
      })
      .finally(() => {
        // Hide the loader once processing is complete, regardless of success or failure
        hideLoader();
      });
  };

  const handleConnectQuickBook = () => {
    showLoader();
    dispatch(userActions.getSettingAndCheckRefreshToken())
      .then((response) => {
        if (
          response.type === "users/getSettingAndCheckRefreshToken/fulfilled"
        ) {
          if (response.payload?.IsRefreshTokenExpired === false) {
            hideLoader();
            let Id = encryptData(currentUser.Id);
            const QuickBookURL = `${process.env.REACT_APP_API_URL}/QuickBookApi/ConnectQuickBook/${Id}`;
            window.open(QuickBookURL, "_blank");
          } else {
            Toastr("Quickbooks already connected.", "warning");
          }
        } else {
          Toastr("Quickbooks already connected.", "warning");
        }
      })
      .catch((error) => {
        console.error("API call failed:", error);
        Toastr("Network error or server issue.", "warning");
      })
      .finally(() => hideLoader());
  };

  const handleGetFilter = (id) => {
    setviewFilter([...id]);
  };

  const handleViewOrder = (orderDetail) => {
    if (viewFilter.length > 0) {
      localStorage.setItem(`filterValues`, JSON.stringify(viewFilter));
    }
    dispatch(orderActions.clearOrderResponse());
    navigate("/ViewOrder", {
      state: orderDetail,
    });
  };

  //Dispatch Details
  const dispatchdetails = (orderDetail) => {
    if (viewFilter.length > 0) {
      localStorage.setItem(`filterValues`, JSON.stringify(viewFilter));
    }
    if (
      orderDetail?.OrderStatusID === 6 &&
      orderDetail?.AdminCourierTypeID === 0
    ) {
      Toastr(
        "Courier Type and Bill of Lading is not updated by Admin",
        "warning"
      );
      return;
    }
    navigate("/DispatchDetails", {
      state: orderDetail,
    });
  };

  // #endregion ------------------  Order List Action --------------------------------

  const handleClickImageClose = () => {
    newAddPaymentData.ImageFilePath = newAddPaymentData.ImageBase64 = null;
    SetPaymentData(newAddPaymentData);
    inputRef.current.value = null;
  };

  // handle Change function
  const handleChange = (event) => {
    event.preventDefault();
    const regexString = /^[a-zA-Z\s]*$/;
    const regexNumber = /^[0-9\b]+$/;
    const fieldName = event.target.getAttribute("name");
    const fieldValue = event.target.value;
    if (fieldValue && fieldValue.trim()) {
      if (fieldName === "CancelledReason") {
        if (fieldValue === "" || regexString.test(fieldValue)) {
          newFormData[fieldName] = fieldValue;
        } else {
          newFormData[fieldName] = fieldValue;
        }
      }
    } else {
      newFormData[fieldName] = fieldValue.trim();
    }
    setAddFormData(newFormData);
  };

  const newAddPaymentData = { ...addPaymentData };
  /// handlePayment Transaction Change
  const handlePaymentTransChange = (event) => {
    const regexNumber = /^[0-9\b]+$/;
    const regexCurrency = /^(\$?[$ 0-9,.]+)$/;
    const fieldName = event.target.getAttribute("name");
    const fieldValue = event.target.value;

    if (fieldValue && fieldValue.trim()) {
      if (fieldName === "PaymentAmount") {
        if (fieldValue === "" || regexCurrency.test(fieldValue)) {
          let currencyValue;
          try {
            currencyValue = parseFloat(fieldValue.replace(/\$|,/g, ""));
          } catch {
            currencyValue = fieldValue;
          }
          currencyValue = currencyValue.toString();

          if (
            (!fieldValue.includes(".") && currencyValue.length <= 8) ||
            (fieldValue.includes(".") &&
              currencyValue.split(".")[0].length <= 8 &&
              fieldValue.split(".")[1].length <= 2)
          ) {
            newAddPaymentData[fieldName] = fieldValue;
          }
        }
      } else if (fieldName === "CheckNumber") {
        if (fieldValue === "" || regexNumber.test(fieldValue)) {
          newAddPaymentData[fieldName] = fieldValue;
        }
      } else {
        newAddPaymentData[fieldName] = fieldValue;
      }
    } else {
      newAddPaymentData[fieldName] = fieldValue.trim();
    }
    SetPaymentData(newAddPaymentData);
  };

  const handleBlur = (event) => {
    const newAddPaymentData = { ...addPaymentData };
    // let newFormData = { ...generalTabData };
    const fieldName = event.target.getAttribute("name");
    const fieldValue = event.target.value;
    if (fieldValue && fieldValue.trim()) {
      if (fieldName === "PaymentAmount") {
        if (fieldValue) {
          newAddPaymentData[fieldName] = fCurrency(fieldValue);
        }
      }
    }
    SetPaymentData(newAddPaymentData);
  };

  const convertBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const fileReader = new FileReader();
      fileReader.readAsDataURL(file);
      fileReader.onload = () => {
        resolve(fileReader.result);
      };
      fileReader.onerror = (error) => {
        reject(error);
      };
    });
  };

  // Add contact function
  const UploadImages = async (e) => {
    const files = e.target.files;
    let file = files[0];

    if (file) {
      const fileType = file["type"];
      const validImageTypes = ["image/jpeg", "image/jpg", "image/png"];
      if (!validImageTypes.includes(fileType)) {
        Toastr("Invalid file format selected", "warning");
      } else {
        const MAX_FILE_SIZE = 5120; // 5MB
        const fileSizeKiloBytes = file.size / 1024;

        if (fileSizeKiloBytes > MAX_FILE_SIZE) {
          Toastr("File size is greater than maximum 5MB", "warning");
        } else {
          let base64 = await convertBase64(file);
          let formData = new FormData();
          formData.append("file", file);
          newAddPaymentData.ImageBase64 = base64;
          SetPaymentData(newAddPaymentData);
        }
      }
    }
  };

  const uploadLadingImg = async (e) => {
    const files = e.target.files;
    let file = files[0];

    if (file) {
      const fileType = file["type"];
      const validImageTypes = ["image/jpeg", "image/jpg", "image/png"];
      if (!validImageTypes.includes(fileType)) {
        setSubmitted(true);
        Toastr("Invalid file format selected", "warning");
        setCourierDetails({
          ...courierDetails,
          AdminBillFilePath: "",
        });
        e.target.value = "";
        return;
      } else {
        setSubmitted(false);
        const MAX_FILE_SIZE = 5120; // 5MB
        const fileSizeKiloBytes = file.size / 1024;

        if (fileSizeKiloBytes > MAX_FILE_SIZE) {
          Toastr("File size is greater than maximum 5MB", "warning");
        } else {
          let base64 = await convertBase64(file);
          let formData = new FormData();
          formData.append("file", file);
          setCourierDetails({
            ...courierDetails,
            ImageBase64: base64,
          });
        }
      }
    }
  };

  const handleCourierTypeDrpChange = (event, title) => {
    // Find the full selected courier object from the dropdown list
    const selectedCourier = courierTypeDrpList.find(
      (item) => parseInt(item.value) === parseInt(event.value)
    );
    setCourierDetails((prev) => ({
      ...prev, // keep existing state
      [title]: event?.value, // update the specific field (usually AdminCourierTypeID)
      CourierTypeOptions: {
        value: parseInt(event.value),
        label: event.label,
        IsSkipBoL: Number(selectedCourier?.IsSkipBoL || 0), // ensure numeric
      },
      IsSkipBoL: Number(selectedCourier?.IsSkipBoL || 0), // also store at root
    }));
  };

  // handle Dropdown Change Payment Transaction function
  const handleDrpPayTransChange = (event, title) => {
    newAddPaymentData[title] = event.value && parseInt(event.value);
    if (title === "PaymentTypeID") {
      newAddPaymentData.PaymentTypeOption = {
        value: parseInt(event.value),
        label: event.label,
      };
    }
    SetPaymentData(newAddPaymentData);
  };

  // handle Dropdown Change function OrderAssign
  const orderForAssignData = { ...orderAssignData };
  const handleOrderAssignDrpChange = (event, title) => {
    orderForAssignData[title] = event.value && parseInt(event.value);
    if (title === "WareHouseID") {
      orderForAssignData.WarehouseAssignOption = {
        value: parseInt(event.value),
        label: event.label,
      };
    } else if (title === "AssignedPrepperID") {
      orderForAssignData.PrepperOption = {
        value: parseInt(event.value),
        label: event.label,
      };
    } else if (title === "AssignedDispatcherID") {
      orderForAssignData.DispatcherOption = {
        value: parseInt(event.value),
        label: event.label,
      };
    }

    SetOrderAssignData(orderForAssignData);
  };

  // #region ------------------ Change Order Status --------------------------------

  const changeOrderStatus = (OrderDetail) => {
    clearSession();
    newFormData.OrderID = OrderDetail.OrderID;
    if (currentUser.UserTypeID === 3) {
      // UserTypeID 3 =>Order Analyst
      setOrderStatusList(
        orderStatusDrpList.filter(
          (d) => d.value === enumOrderStatus.OrderPrepared
        )
      ); // order Status 3 =>Order Prepared
    }
    if (currentUser.UserTypeID === 4) {
      // UserTypeID 4 =>Dispatcher

      setOrderStatusList(
        orderStatusDrpList.filter(
          (d) => d.value === enumOrderStatus.ReadyToDispatch
        )
      ); // order Status 6 =>ReadytoDispatch
    } else if (currentUser.UserTypeID === 1 || currentUser.UserTypeID === 2) {
      let orderStatusID =
        OrderDetail.OrderStatusID === enumOrderStatus.OrderPrepared
          ? enumOrderStatus.InvoiceSent
          : OrderDetail.OrderStatusID === enumOrderStatus.OrderDispatched
          ? enumOrderStatus.ReadyToDispatch
          : 0; // order Status  =>4 Invoice Sent or Ready to Dispatch
      if (
        orderStatusID === enumOrderStatus.InvoiceSent ||
        orderStatusID === enumOrderStatus.ReadyToDispatch
      ) {
        setOrderStatusList(
          orderStatusDrpList.filter((d) => d.value === orderStatusID)
        );
      } else {
        setOrderStatusList([]);
      }
    }
    newFormData.OrderStatusOptions = null;
    newFormData.ClientID = OrderDetail.ClientID;
    newFormData.IsPartyDeco = OrderDetail.IsPartyDeco;
    newFormData.OrderNumber = OrderDetail.OrderNumber;
    newFormData.AssignedDispatcherID = OrderDetail.AssignedDispatcherID;
    setAddFormData(newFormData);
    setOpenModal(true);
    setSubmitted(false);
  };

  // handle Dropdown Change function ChangeOrderStatus
  const handleChangeStatusDrpChange = (event, title) => {
    newFormData[title] = event.value && parseInt(event.value);
    if (currentUser.UserTypeID !== 1 || currentUser.UserTypeID !== 2) {
      if (title === "OrderStatusID") {
        newFormData.OrderStatusOptions = {
          value: parseInt(event.value),
          label: event.label,
        };
      }
      setAddFormData(newFormData);
    }
  };

  // Change Order Status Save
  const changeOrderStatusSubmit = (event) => {
    setSubmitted(true);
    if (newFormData.OrderStatusOptions) {
      newFormData.OrderStatusID = newFormData.OrderStatusOptions.value;
      // newFormData.IsPartyDeco = orderDetail.IsPartyDeco;
      dispatch(orderActions.changeOrderStatus(newFormData));

      setOpenModal(false);
    } else {
      Toastr("Please select order status", "warning");
    }
  };

  //Change Order Status Update
  useEffect(() => {
    if (orderResponse === 1) {
      Toastr("Order Status  updated successfully", "success");
      dispatch(
        orderActions.GetOrderList({
          OrderID: 0,
          ClientID: 0,
          OrderSourceID: 0,
          Status: 1,
          OrderStatusID: 0,
          UserID: currentUser.Id,
          UserTypeID: currentUser.UserTypeID,
        })
      );
      setOpenModal(false);
      setAddFormData(newFormData);
    }
  }, [orderResponse]);

  useEffect(() => {
    const selectedDrpDwnList = courierTypeDrpList?.filter(
      (item) => item?.value === orderCourierDetails?.AdminCourierTypeID
    );

    if (selectedDrpDwnList?.length > 0) {
      const selectedCourier = selectedDrpDwnList[0];

      setCourierDetails((prev) => ({
        ...prev, // keep existing fields
        AdminBillFilePath: orderCourierDetails.AdminBillFilePath,
        AdminCourierTypeID: orderCourierDetails.AdminCourierTypeID,
        CourierTypeOptions: selectedCourier,
        IsSkipBoL: selectedCourier.IsSkipBoL || 0, // add IsSkipBoL safely
      }));
    }
  }, [orderCourierDetails, courierTypeDrpList]);

  useEffect(() => {
    if (orderCourierResponse === 1 || orderCourierResponse === 2) {
      dispatch(
        orderActions.GetOrderList({
          OrderID: 0,
          ClientID: 0,
          OrderSourceID: 0,
          Status: 1,
          OrderStatusID: 0,
          UserID: currentUser.Id,
          UserTypeID: currentUser.UserTypeID,
        })
      );
    }
  }, [orderCourierResponse]);

  //order Cancelled status update
  useEffect(() => {
    if (orderCancelResponse === 1) {
      dispatch(orderActions.clearOrderResponse());
      Toastr("Order Cancelled Successfully", "success");
      dispatch(
        orderActions.GetOrderList({
          OrderID: 0,
          ClientID: 0,
          OrderSourceID: 0,
          Status: 1,
          OrderStatusID: 0,
          UserID: currentUser.Id,
          UserTypeID: currentUser.UserTypeID,
        })
      );
      newFormData.CancelledReason = "";
      setCancelModal(false);
      setAddFormData(newFormData);
    }
  }, [orderCancelResponse]);

  // #endregion ------------------  Change Order Status --------------------------------

  // #region ------------------ Order Assign (Allocation)--------------------------------

  // OrderAssignPopup
  const handleOrderAssign = (OrderDetail) => {
    //  const data = { OrderStatusID: OrderDetail.OrderStatusID };
    clearSession();

    orderAssignData.OrderID = OrderDetail.OrderID;
    orderAssignData.OrderNumber = OrderDetail.OrderNumber;
    orderAssignData.OrderStatusID = OrderDetail.OrderStatusID;
    orderAssignData.IsPartyDeco = OrderDetail.IsPartyDeco;
    if (OrderDetail.OrderStatusID === enumOrderStatus.OrderCreated) {
      orderAssignData.WarehouseAssignOption =
        orderAssignData.DispatcherOption =
        orderAssignData.PrepperOption =
          null;
    } else if (
      orderAssignData.OrderStatusID === enumOrderStatus.OrderPrepared
    ) {
      orderAssignData.WarehouseAssignOption = {
        value: OrderDetail.WareHouseID,
        label: OrderDetail.WareHouseNumber,
      };

      orderAssignData.DispatcherOption = {
        value: OrderDetail.AssignedDispatcherID,
        label: OrderDetail.AssignedDispatcher,
      };
      orderAssignData.PrepperOption = {
        value: OrderDetail.AssignedPrepperID,
        label: OrderDetail.AssignedPrepper,
      };
      orderAssignData.WareHouseID = orderAssignData.WarehouseAssignOption.value;
      orderAssignData.AssignedDispatcherID =
        orderAssignData.DispatcherOption.value;
      orderAssignData.AssignedPrepperID = orderAssignData.PrepperOption.value;
    } else {
      orderAssignData.OrderID = OrderDetail.OrderID;
      orderAssignData.WarehouseAssignOption = {
        value: OrderDetail.WareHouseID,
        label: OrderDetail.WareHouseNumber,
      };
      orderAssignData.DispatcherOption = {
        value: OrderDetail.AssignedDispatcherID,
        label: OrderDetail.AssignedDispatcher,
      };
      orderAssignData.PrepperOption = {
        value: OrderDetail.AssignedPrepperID,
        label: OrderDetail.AssignedPrepper,
      };
      orderAssignData.WareHouseID = orderAssignData.WarehouseAssignOption.value;
      orderAssignData.AssignedDispatcherID =
        orderAssignData.DispatcherOption.value;
      orderAssignData.AssignedPrepperID = orderAssignData.PrepperOption.value;
    }

    orderAssignData.ClientID = OrderDetail.ClientID;

    SetOrderAssignData(orderAssignData);
    setOrderAssignModal(true);
    setSubmitted(false);
  };

  //OrderAssign Submit
  const handleAssignSubmit = (event) => {
    event.preventDefault();
    var error = false;

    var errorMsg = "";
    if (
      !orderAssignData.WareHouseID ||
      !orderAssignData.AssignedDispatcherID ||
      !orderAssignData.AssignedPrepperID
    ) {
      error = true;
      Toastr("Please fill in the required missing fields", "warning");
    } else if (orderAssignData.OrderStatusID >= enumOrderStatus.OrderPrepared) {
      orderAssignData.AssignedPrepperID = 0;
    }

    if (!error) {
      dispatch(
        orderActions.saveOrderAssign({
          OrderID: orderAssignData.OrderID,
          WareHouseID: orderAssignData.WareHouseID,
          AssignedPrepperID: orderAssignData.AssignedPrepperID,
          AssignedDispatcherID: orderAssignData.AssignedDispatcherID,
          CreatedBy: orderAssignData.CreatedBy,
          OrderNumber: orderAssignData.OrderNumber,
          ClientID: orderAssignData.ClientID,
          IsPartyDeco: orderAssignData.IsPartyDeco,
        })
      );
    } else {
      setSubmitted(true);
    }
  };

  //orderAssign Update
  useEffect(() => {
    if (orderAssignResponse === 1) {
      dispatch(orderActions.clearOrderResponse());
      Toastr("Order Assign updated successfully", "success");
      dispatch(
        orderActions.GetOrderList({
          OrderID: 0,
          ClientID: 0,
          OrderSourceID: 0,
          Status: 1,
          OrderStatusID: 0,
          UserID: currentUser.Id,
          UserTypeID: currentUser.UserTypeID,
        })
      );
      setOrderAssignModal(false);
      setSubmitted(false);
      SetOrderAssignData(orderAssignData);
    }
  }, [orderAssignResponse]);

  // #endregion ------------------  Order Assign (Allocation)--------------------------------

  // #region ------------------Payment--------------------------------

  //skidBreakdownDetails Update

  useEffect(() => {
    if (skidBreakdownDetails === 1) {
      dispatch(orderActions.clearOrderResponse());
      Toastr("Skid Breakdown updated successfully", "success");
      dispatch(
        orderActions.GetOrderList({
          OrderID: 0,
          ClientID: 0,
          Status: 1,
          UserID: currentUser.Id,
          UserTypeID: currentUser.UserTypeID,
        })
      );
      setSkidBreakdown(skidBreakdown);
      setSkidBreakdownModal(false);
      setSubmitted(false);
    }
  }, [skidBreakdownDetails]);

  const changePaymentStatus = (PaymentDetail) => {
    clearSession();
    newAddPaymentData.IsNoPayment = newAddPaymentData.ImageBase64 = null;
    newAddPaymentData.PaymentTypeOption = { value: 8, label: "QB" };
    newAddPaymentData.CheckNumber = "";
    newAddPaymentData.PaymentTypeID = 8;
    newAddPaymentData.PaymentAmount = fCurrency(PaymentDetail.GrandTotal);
    newAddPaymentData.GrandTotal = PaymentDetail.GrandTotal;
    newAddPaymentData.OrderID = PaymentDetail.OrderID;
    newAddPaymentData.OrderNumber = PaymentDetail.OrderNumber;
    newAddPaymentData.ClientName = PaymentDetail.ClientName;
    newAddPaymentData.IsPartyDeco = PaymentDetail.IsPartyDeco;
    SetPaymentData(newAddPaymentData);
    setPaymentModal(true);
    setSubmitted(false);
  };

  // Payment Submit
  const handlePaymentSubmit = (event) => {
    var error = false;
    var errorMsg = "";
    let alertMsg;

    // if (newAddPaymentData.IsNoPayment) {
    //   newAddPaymentData.PaymentAmount = "0";
    //   SetPaymentData(newAddPaymentData);
    //   }

    if (
      newAddPaymentData.IsNoPayment ||
      newAddPaymentData.PaymentTypeID === 8
    ) {
      if (
        !newAddPaymentData.PaymentAmount ||
        newAddPaymentData.PaymentAmount === "$0.00" ||
        newAddPaymentData.PaymentAmount === ""
      ) {
        newAddPaymentData.PaymentAmount = newAddPaymentData.GrandTotal;
        SetPaymentData(newAddPaymentData);
      }
    } else {
      if (
        !newAddPaymentData.PaymentAmount ||
        newAddPaymentData.PaymentAmount === "$0.00" ||
        newAddPaymentData.PaymentAmount === ""
      ) {
        error = true;
        alertMsg = "Please fill in the all required fields";
      }
    }

    if (
      (currentUser.UserTypeID === 1 &&
        (newAddPaymentData.IsNoPayment === false ||
          !newAddPaymentData.IsNoPayment)) ||
      currentUser.UserTypeID === 2
    ) {
      let PaymentAmount;
      try {
        PaymentAmount = parseFloat(
          newAddPaymentData.PaymentAmount.replace(/\$|,/g, "")
        );
      } catch {
        PaymentAmount = newAddPaymentData.PaymentAmount;
      }
      newAddPaymentData.PaymentAmount = PaymentAmount;
      if (
        !newAddPaymentData.PaymentTypeID ||
        !newAddPaymentData.PaymentAmount ||
        parseFloat(newAddPaymentData.PaymentAmount) <= 0
      ) {
        error = true;
        alertMsg = "Please fill in the all required fields";
      }

      if (!error) {
        if (newAddPaymentData.PaymentTypeID === 8) {
          newAddPaymentData.PaymentAmount = newAddPaymentData.GrandTotal;
          SetPaymentData(newAddPaymentData);
        } else {
          if (
            parseFloat(newAddPaymentData.GrandTotal) <
            parseFloat(newAddPaymentData.PaymentAmount)
          ) {
            error = true;
            alertMsg = "Payment Amount is  more than Grand Total";
          }
        }
      }

      if (newAddPaymentData.PaymentTypeID === 3) {
        if (
          !newAddPaymentData.CheckNumber ||
          !newAddPaymentData.PaymentTypeID === 0
        ) {
          error = true;
          alertMsg = "Please fill in the all required fields";
          // Toastr('Please fill in the required missing fields', 'warning');
        }
      }
    }

    if (!error) {
      dispatch(orderActions.savePaymentTransaction(newAddPaymentData));
    } else {
      setSubmitted(true);
      // Toastr('Please fill in the required missing fields', 'warning');
      alertMsg && Toastr(`${alertMsg}`, "warning");
    }
  };

  ///Payment Update
  useEffect(() => {
    if (orderPaymentTransactionResponse === 1) {
      dispatch(orderActions.clearOrderResponse());
      Toastr("Payment updated successfully", "success");
      dispatch(
        orderActions.GetOrderList({
          OrderID: 0,
          ClientID: 0,
          OrderSourceID: 0,
          Status: 1,
          OrderStatusID: 0,
          UserID: currentUser.Id,
          UserTypeID: currentUser.UserTypeID,
        })
      );
      setPaymentModal(false);
      setSubmitted(false);
      SetPaymentData(newAddPaymentData);
    }
  }, [orderPaymentTransactionResponse]);

  //No payment
  const handleCheckNoPayment = (event) => {
    if (event.target.checked === true) {
      newAddPaymentData.IsNoPayment = true;
      newAddPaymentData.PaymentAmount = 0;
      newAddPaymentData.PaymentTypeID = 0;
      newAddPaymentData.PaymentTypeOption = "";
      SetPaymentData(newAddPaymentData);
    } else if (event.target.checked === false) {
      newAddPaymentData.IsNoPayment = false;
      newAddPaymentData.PaymentTypeID = 8;
      newAddPaymentData.PaymentTypeOption = { value: 8, label: "QB" };
      newAddPaymentData.PaymentAmount = fCurrency(newAddPaymentData.GrandTotal);
      SetPaymentData(newAddPaymentData);
    }
  };

  // #endregion ------------------ Payment--------------------------------

  // #region ------------------ Order Cancel--------------------------------
// ===== START ADMIN CANCEL CHANGES =====
const onSubmitAdminPasscodeVerify = (orderDetail) => {

    setSelectedCancelOrder(orderDetail);

    setCancelAuthorization({
        isAdminPasscodeValid: false,
        AdminPasscode: "",
        CancelledReason: ""
    });

    setIsRevealPwd(false);

    // Both flows open the same Cancel modal.
    // The modal itself decides whether to show the
    // Admin Password step or the Reason step based on OrderStatusID.
    handleCancelOrder(orderDetail);

}

const handleAdminPasswordChange = (event) => {
    const fieldValue = event.target.value;
    setCancelAuthorization((prev) => ({
        ...prev,
        AdminPasscode: fieldValue,
    }));
};

// New function: verifies admin passcode using the SAME
// verifyAdminPasscode action already used in WeightVerification.jsx
const handleVerifyAdminPasscode = () => {
    if (!cancelAuthorization.AdminPasscode || !cancelAuthorization.AdminPasscode.trim()) {
        Toastr("Please enter admin passcode", "warning");
        return;
    }

    let adminPasscodeData = {
        Passcode: cancelAuthorization.AdminPasscode,
    };

    dispatch(orderActions.verifyAdminPasscode(adminPasscodeData)).then(
        (response) => {
            if (response.type === "order/verifyAdminPasscode/fulfilled") {
                if (response && response.payload === 1) {
                    Toastr("Admin passcode verified successfully", "success");
                    setCancelAuthorization((prev) => ({
                        ...prev,
                        isAdminPasscodeValid: true,
                    }));
                } else {
                    Toastr("Invalid Admin Passcode", "warning");
                }
            } else {
                Toastr("Invalid Admin Passcode", "warning");
            }
        }
    );
};
// ===== END ADMIN CANCEL CHANGES =====


  //CancelOrder  Popup
  const handleCancelOrder = (orderDetail) => {
    clearSession();

    newFormData.OrderID = orderDetail.OrderID;
    newFormData.OrderNumber = orderDetail.OrderNumber;
    newFormData.ClientID = orderDetail.ClientID;
    newFormData.IsPartyDeco = orderDetail.IsPartyDeco;

    setAddFormData(newFormData);
    dispatch(
      orderActions.GetOrderDetailsByID({ OrderID: orderDetail.OrderID })
    );
    setCancelModal(true);
    setSubmitted(false);
  };

  const handleCourierDetails = (orderDetail) => {
    clearSession();
    if (orderDetail.IsOrderSkidBreakdown === false) {
      Toastr(
        "Please complete the Skid Breakdown and then adding the Order Courier.",
        "warning"
      );
    } else {
      getCourierDetails(orderDetail?.OrderID);
      setCourierDetails({
        ...courierDetails,
        OrderNumber: orderDetail?.OrderNumber,
        OrderID: orderDetail?.OrderID,
        AssignedDispatcherID: orderDetail?.AssignedDispatcherID,
        ClientID: orderDetail?.ClientID,
        IsPartyDeco: orderDetail?.IsPartyDeco,
      });
      setCourierModal(true);
      setCourierModalDetails(orderDetail);
    }
  };

  const getCourierDetails = (orderID) => {
    dispatch(orderActions.GetOrderCourierDetails(orderID));
  };

  // close popup
  // const handleClosePopup = () => {
  //   dispatch(orderActions.clearOrderResponse());
  //   setOpenModal(false);
  //   setCancelModal(false);
  //   setOrderAssignModal(false);
  //   setPaymentModal(false);
  //   setLabelModal(false);
  //   setSkidBreakdownModal(false);
  //   setOrderReversedModal(false);
  // };

  // ===== START ADMIN CANCEL CHANGES =====
// close popup
const handleClosePopup = () => {
    dispatch(orderActions.clearOrderResponse());
    setOpenModal(false);
    setCancelModal(false);
    setOrderAssignModal(false);
    setPaymentModal(false);
    setLabelModal(false);
    setSkidBreakdownModal(false);
    setOrderReversedModal(false);

    // Reset Admin Cancel Authorization state so the popup
    // always starts fresh next time it's opened.
    setCancelAuthorization({
      isAdminPasscodeValid: false,
      AdminPasscode: "",
      CancelledReason: "",
    });
    setSelectedCancelOrder(null);
    setIsRevealPwd(false);
};
// ===== END ADMIN CANCEL CHANGES =====

  const handleCloseCourierPopup = () => {
    setCourierModal(false);
    setCourierDetails({
      AdminCourierTypeID: "",
      AdminBillFilePath: "",
      CourierTypeOptions: {},
      OrderNumber: 0,
      OrderID: 0,
    });
  };

  const handleCourierDetailsSubmit = (event) => {
    event.preventDefault();
    const {
      AdminCourierTypeID,
      CourierTypeOptions,
      AdminBillFilePath,
      ImageBase64,
      IsSkipBoL,
    } = courierDetails;
    const label = CourierTypeOptions?.label?.toUpperCase();
    const skipBOL = Number(IsSkipBoL); // ensure numeric comparison
    // Validate required Courier Type
    if (!AdminCourierTypeID) {
      setSubmitted(true);
      Toastr("Please fill in the required missing fields", "warning");
      return;
    }

    // Validate Bill of Lading if required
    if (skipBOL === 0) {
      if (!AdminBillFilePath && !ImageBase64) {
        setSubmitted(true);
        Toastr("Please fill in the required missing fields", "warning");
        return;
      }
    }
    // Clear Bill of Lading for UPS or skipBOL = 1
    if (skipBOL === 1) {
      setCourierDetails((prev) => ({
        ...prev,
        AdminBillFilePath: "",
        ImageBase64: "",
      }));
    }
    showLoader();
    setSubmitted(false);

    const courierData = { ...courierDetails };
    delete courierData.CourierTypeOptions;

    dispatch(orderActions.AddCourierDetails(courierData));
    Toastr("Order Courier Details saved successfully", "success");
    handleCloseCourierPopup();
    hideLoader();
  };

  //Order Cancel Submit
  // const handleCancelSubmit = (event) => {
  //   event.preventDefault();
  //   var error = false;
  //   if (!addFormData.CancelledReason) {
  //     error = true;
  //     Toastr("Please fill in the required missing fields", "warning");
  //   }
  //   if (!error) {
  //     showLoader();
  //     if (orderDetail && orderDetail.OrderID > 0) {
  //       let gemar_data = [];
  //       let PD_data = [];

  //       let OrderProductList = [...orderDetail.OrderProductModelList];
  //       OrderProductList &&
  //         OrderProductList.map((model) => {
  //           let availQty = model.AvailableQuantity + model.Quantity;

  //           if (model.IsGemar === true) {
  //             let data = {
  //               id: model.WCProductID,
  //               stock_quantity: availQty,
  //             };
  //             gemar_data.push(data);
  //           }

  //           if (model.IsPartyDeco === true) {
  //             let data = {
  //               id: model.PDWCProductID,
  //               stock_quantity: availQty,
  //             };
  //             PD_data.push(data);
  //           }
  //         });

  //       let pageStatus = "OrderCancel";

  //       if (
  //         gemar_data &&
  //         gemar_data.length > 0 &&
  //         PD_data &&
  //         PD_data.length > 0
  //       ) {
  //         AddUpdateOrder_GemarAndPD(gemar_data, PD_data, pageStatus);
  //       } else if (gemar_data && gemar_data.length > 0) {
  //         AddUpdateOrder_Gemar(gemar_data, pageStatus);
  //       } else if (PD_data && PD_data.length > 0) {
  //         AddUpdateOrder_PD(PD_data, pageStatus);
  //       } else {
  //         hideLoader();
  //       }
  //     } else {
  //       Toastr("Please try again", "warning");
  //       hideLoader();
  //     }
  //   } else {
  //     setSubmitted(true);
  //   }
  // };

  // ===== START ADMIN CANCEL CHANGES =====
//Order Cancel Submit
const handleCancelSubmit = (event) => {
    event.preventDefault();
    var error = false;

    // Guard: for OrderStatusID >= 4 (and != 8), Submit must never
    // run before Admin Passcode has been verified.
    const requiresAdminAuth =
      selectedCancelOrder &&
      selectedCancelOrder.OrderStatusID >= 4 &&
      selectedCancelOrder.OrderStatusID !== 8;

    if (requiresAdminAuth && !cancelAuthorization.isAdminPasscodeValid) {
      Toastr("Please verify admin passcode first", "warning");
      return;
    }

    if (!addFormData.CancelledReason) {
      error = true;
      Toastr("Please fill in the required missing fields", "warning");
    }
    if (!error) {
      showLoader();
      
       newFormData.CancelPasscode = requiresAdminAuth
        ? cancelAuthorization.AdminPasscode
        : "";

      if (orderDetail && orderDetail.OrderID > 0) {
        let gemar_data = [];
        let PD_data = [];

        let OrderProductList = [...orderDetail.OrderProductModelList];
        OrderProductList &&
          OrderProductList.map((model) => {
            let availQty = model.AvailableQuantity + model.Quantity;

            if (model.IsGemar === true) {
              let data = {
                id: model.WCProductID,
                stock_quantity: availQty,
              };
              gemar_data.push(data);
            }

            if (model.IsPartyDeco === true) {
              let data = {
                id: model.PDWCProductID,
                stock_quantity: availQty,
              };
              PD_data.push(data);
            }
          });

        let pageStatus = "OrderCancel";

        if (
          gemar_data &&
          gemar_data.length > 0 &&
          PD_data &&
          PD_data.length > 0
        ) {
          AddUpdateOrder_GemarAndPD(gemar_data, PD_data, pageStatus);
        } else if (gemar_data && gemar_data.length > 0) {
          AddUpdateOrder_Gemar(gemar_data, pageStatus);
        } else if (PD_data && PD_data.length > 0) {
          AddUpdateOrder_PD(PD_data, pageStatus);
        } else {
          hideLoader();
        }
      } else {
        Toastr("Please try again", "warning");
        hideLoader();
      }
    } else {
      setSubmitted(true);
    }
};
// ===== END ADMIN CANCEL CHANGES =====

  function AddUpdateOrder_GemarAndPD(gemar_data, PD_data, pageStatus) {
    const batchSize = 200; // Define the batch size
    let gemarPage = 0;
    let PDPage = 0;
    let totalGemarPages = Math.ceil(gemar_data.length / batchSize);
    let totalPDPages = Math.ceil(PD_data.length / batchSize);

    // Function to update a batch for Gemar API
    const updateGemarBatch = (batchData, page) => {
      let gemarData = {
        update: batchData,
      };

      restApi
        .post("products/batch", gemarData) // Gemar API
        .then((response) => {
          if (
            response.status === 200 ||
            response.status === 201 ||
            !response.statusText
          ) {
            if (page < totalGemarPages - 1) {
              // Move to the next Gemar batch
              gemarPage++;
              sendNextGemarBatch(gemarPage);
            } else {
              // Once Gemar batches are done, proceed to Party Deco API
              sendNextPDBatch(PDPage);
            }
          } else {
            hideLoader();
            Toastr(response.statusText, "warning");
          }
        })
        .catch((error) => {
          hideLoader();
          let msg = error.response
            ? error.response.data.message
            : "rest Api error";
          Toastr(msg, "warning");
        });
    };

    // Function to update a batch for Party Deco API
    const updatePDBatch = (batchData, page) => {
      let PDData = {
        update: batchData,
      };

      restApi_PD
        .put("products/batch", PDData) // Party Deco API
        .then((PDResponse) => {
          if (
            PDResponse.status === 200 ||
            PDResponse.status === 201 ||
            !PDResponse.statusText
          ) {
            if (page < totalPDPages - 1) {
              // Move to the next Party Deco batch
              PDPage++;
              sendNextPDBatch(PDPage);
            } else {
              if (pageStatus === "OrderCancel") {
                // All batches processed, dispatch save order action
                newFormData.IsPartyDeco = orderDetail.IsPartyDeco;
                dispatch(orderActions.orderCancel(newFormData));
              } else if (pageStatus === "OrderReversed") {
                updateOrderReversed();
              }
            }
          } else {
            hideLoader();
            Toastr(PDResponse.statusText, "warning");
          }
        })
        .catch((error) => {
          hideLoader();
          let msg = error.response
            ? error.response.data.message
            : "rest Api error";
          Toastr(msg, "warning");
        });
    };

    // Function to send the next batch of Gemar data
    const sendNextGemarBatch = (page) => {
      let start = page * batchSize;
      let end = start + batchSize;
      let batchData = gemar_data.slice(start, end); // Get the next Gemar batch

      if (batchData.length > 0) {
        updateGemarBatch(batchData, page);
      }
    };

    // Function to send the next batch of Party Deco data
    const sendNextPDBatch = (page) => {
      let start = page * batchSize;
      let end = start + batchSize;
      let batchData = PD_data.slice(start, end); // Get the next Party Deco batch

      if (batchData.length > 0) {
        updatePDBatch(batchData, page);
      }
    };

    // Start by sending the first batch for Gemar API
    if (gemar_data.length > 0) {
      showLoader(); // Display loader while processing
      sendNextGemarBatch(gemarPage); // Start with Gemar API
    } else if (PD_data.length > 0) {
      // If no Gemar data but Party Deco data exists, process Party Deco directly
      sendNextPDBatch(PDPage);
    } else {
      hideLoader();
      Toastr("No data to update", "warning");
    }
  }

  function AddUpdateOrder_Gemar(gemar_data, pageStatus) {
    // Maximum items per batch (pagination)
    const batchSize = 200;
    let page = 0; // Track the current page
    let totalPages = Math.ceil(gemar_data.length / batchSize); // Calculate total pages

    // Function to update the order for each batch
    const updateBatch = (batchData, page) => {
      let gemarData = {
        update: batchData,
      };

      // Send the API request for the current batch
      restApi
        .post("products/batch", gemarData) // Gemar API
        .then((response) => {
          if (
            response.status === 200 ||
            response.status === 201 ||
            !response.statusText
          ) {
            if (page < totalPages - 1) {
              // Move to the next page/batch
              page++;
              sendNextBatch(page);
            } else {
              if (pageStatus === "OrderCancel") {
                // All batches processed, dispatch save order action
                newFormData.IsPartyDeco = orderDetail.IsPartyDeco;
                dispatch(orderActions.orderCancel(newFormData));
              } else if (pageStatus === "OrderReversed") {
                updateOrderReversed();
              }
            }
          } else {
            hideLoader();
            Toastr(response.statusText, "warning");
          }
        })
        .catch((error) => {
          hideLoader();
          let msg = "";
          if (error.response) {
            msg = error.response.data.message;
          } else {
            msg = "rest Api error";
          }
          Toastr(msg, "warning");
        });
    };

    // Function to send the next batch of data
    const sendNextBatch = (page) => {
      let start = page * batchSize;
      let end = start + batchSize;
      let batchData = gemar_data.slice(start, end); // Get the next batch of data

      // Send batch to the API
      updateBatch(batchData, page);
    };

    // Start by sending the first batch
    if (gemar_data.length > 0) {
      showLoader(); // Display loader while processing
      sendNextBatch(page); // Start with the first page
    } else {
      Toastr("No data to update", "warning");
    }
  }

  function AddUpdateOrder_PD(PD_data, pageStatus) {
    // Maximum items per batch (pagination)
    const batchSize = 200;
    let page = 0; // Track the current page
    let totalPages = Math.ceil(PD_data.length / batchSize); // Calculate total pages

    // Function to update the order for each batch
    const updateBatch = (batchData, page) => {
      let PDData = {
        update: batchData,
      };

      // Send the API request for the current batch
      restApi_PD
        .put("products/batch", PDData) // Party Deco API
        .then((PDResponse) => {
          if (
            PDResponse.status === 200 ||
            PDResponse.status === 201 ||
            !PDResponse.statusText
          ) {
            if (page < totalPages - 1) {
              // Move to the next page/batch
              page++;
              sendNextBatch(page);
            } else {
              if (pageStatus === "OrderCancel") {
                // All batches processed, dispatch save order action
                newFormData.IsPartyDeco = orderDetail.IsPartyDeco;
                dispatch(orderActions.orderCancel(newFormData));
              } else if (pageStatus === "OrderReversed") {
                updateOrderReversed();
              }
            }
          } else {
            hideLoader();
            Toastr(PDResponse.statusText, "warning");
          }
        })
        .catch((error) => {
          hideLoader();
          let msg = "";
          if (error.response) {
            msg = error.response.data.message;
          } else {
            msg = "rest Api error";
          }
          Toastr(msg, "warning");
        });
    };

    // Function to send the next batch of data
    const sendNextBatch = (page) => {
      let start = page * batchSize;
      let end = start + batchSize;
      let batchData = PD_data.slice(start, end); // Get the next batch of data

      // Send batch to the API
      updateBatch(batchData, page);
    };

    // Start by sending the first batch
    if (PD_data.length > 0) {
      showLoader(); // Display loader while processing
      sendNextBatch(page); // Start with the first page
    } else {
      Toastr("No data to update", "warning");
    }
  }

  // #endregion ------------------ Order Cancel--------------------------------

  // #region ------------------ Export File  --------------------------------

  //pdf button
  const handleClickPDF = () => {
    let title = "Order List";
    const columnStyles = {
      OrderNumber: { halign: "center", cellWidth: 40 },
      ClientName: { halign: "left", cellWidth: 40 },
      OrderSource: { halign: "left", cellWidth: 40 },
      Woocommerce: { halign: "left", cellWidth: 40 },
      OrderStatus: { halign: "left", cellWidth: 30 },
      CreatedDateString: { halign: "left", cellWidth: 40 },
      GrandTotalStr: { halign: "right", cellWidth: 40 },
    };

    generatePDF(finalTableData, generateColumns, true, title, columnStyles);
  };

  //excel
  const handleClickExcel = () => {
    let title = "Order List";
    let generateExcelColumns = [
      "Order Id",
      "Client",
      "Order Source",
      "Website",
      "Order Status",
      "Order Date",
      "Grand Total",
    ];
    let new_orderList =
      finalTableData &&
      finalTableData.map(function (obj) {
        return {
          OrderNumber: obj.OrderNumber,
          ClientName: obj.ClientName,
          OrderSource: obj.OrderSource,
          Woocommerce: obj.Woocommerce,
          OrderStatus: obj.OrderStatus,
          CreatedDateString: obj.CreatedDateString,
          GrandTotal: obj.GrandTotalStr,
        };
      });

    generateXlsx(new_orderList, generateExcelColumns, title);
  };

  const handlePackingSlipPDF = (orderDetail) => {
    CommonService.GetOrderPackingSlipByID(orderDetail.OrderID).then((res) => {
      let title = "PackingSlip";
      let orderDetailPrint = res.data;
      if (orderDetailPrint) {
        let tableRows = [...orderDetailPrint.OrderProductModelList];

        dispatch(
          packingSlipPDF(
            tableRows,
            packingSlipColumns,
            false,
            title,
            orderDetailPrint
          )
        );
      } else {
        Toastr("No data in order", "warning");
      }
    });
  };

  // #endregion ------------------ Export File -------------------------------
  const componentRef = useRef();

  // const handleLabelPrint = (useReactToPrint) => {
  //
  //     setLabelModal(true);
  //     setSubmitted(false);

  // };

  const handlePrint = (orderDetail) => {
    setSelected([]);
    setisordervalues(false);
    setisorderLable(false);
    setColumnOrderData([]);
    setOrderNo(orderDetail.OrderNumber);
    setClientName(orderDetail.ClientName);
    dispatch(
      orderActions.GetOrderProductDrpList({ OrderID: orderDetail.OrderID })
    );

    //let OrderID = 0;
    dispatch(
      masterActions.GetBoxNumberDrpList({ OrderID: orderDetail.OrderID })
    );
    setLabelModal(true);
  };

  // -- Print Function with Page Size Set --//
  // const handlePrints = useReactToPrint({
  //   pageStyle: `@media print {
  //           @page {
  //             // size: 4in 5in;
  //              size: landscape;
  //             margin: 0 !important;
  //             padding: 0 !important;
  //           }
  //         }`,

  //   content: () => componentRef.current,
  //   onBeforeGetContent: () => { },
  // });

  const handlePrints = useReactToPrint({
    content: () => componentRef.current,
    pageStyle: `
    @page {
      size: 288px 288px;
      margin: 0;
    }

    body {
      margin: 0;
      padding: 0;
      font-size: 23px !important; /* 🔍 increase font size */
        line-height: 1.4;
        -webkit-print-color-adjust: exact;
        print-color-adjust: exact;
    }

    .print-label {
      width: 288px;
      height: 288px;
      overflow: hidden;
      page-break-after: always;
      display: block;
      box-sizing: border-box;
        font-size: 23px !important; /* 🔍 increase font size */
    }
       * {
        font-family: Arial, sans-serif !important;
      }
  `,
    onBeforeGetContent: () => Promise.resolve(),
  });

  // #endregion ------------------ Export File -------------------------------

  const handleSearch = () => {
    if (OrderSelected && OrderSelected.length > 0) {
      setisordervalues(true);
      setColumnOrderData(OrderSelected);
    } else if (isorderLable === true) {
    } else {
      Toastr("Please enter the box#", "warning");
    }
  };

  const handleClear = () => {
    setColumnOrderData([]);
    setOrderSelected([]);
    setisordervalues(false);
    setisorderLable(false);
    setSelected([]);
  };

  const handleBoxChange = (selected) => {
    if (selected) {
      newAddPaymentData.Box = 1;
      const filtered = selected.filter((item) => {
        return item.value === -1;
      });

      if (filtered.length > 0) {
        setSelected([]);
        setOrderSelected([]);
        setSelected(filtered);
        setisorderLable(true);
        setisordervalues(true);
        //setColumnOrderData(boxNumberDrpList);
        setColumnOrderData(
          boxNumberDrpList.filter((item) => {
            return item.value !== -1;
          })
        );
        setisordervalues(false);
      } else {
        setOrderSelected([]);
        setSelected(selected);
        setOrderSelected(selected);
      }
    } else {
      setOrderSelected([]);
      setSelected([]);
      setOrderSelected([]);
    }
  };

  // const handlePrintShow = () => {
  //
  //     const Orderdata = optionSelected.filter((item) => {
  //         return item.value === -1;
  //     });

  //     if (Orderdata.length > 0) {
  //         setisordervalues(true);
  //         setTimeout(() => {
  //             handlePrints();
  //         }, 5);
  //         setTimeout(() => {
  //             setisordervalues(false);
  //         }, 2);
  //     } else {
  //         if (ColumnOrderdata.length > 0) {
  //             handlePrints();
  //         } else {
  //             Toastr("Not Search selected", "warning");
  //         }
  //     }
  // };

  // #region ------- Print Show Function  --------------

  const handlePrintShow = () => {
    if (ColumnOrderdata.length > 0) {
      setisPrintData(true);
      setTimeout(() => {
        handlePrints();
      }, 5);
      setTimeout(() => {
        setisPrintData(false);
      }, 2);
    } else {
      Toastr("Preview the Print Label before Printing", "warning");
    }
  };

  // #endregion ------ Print Show Function --------------

  // #region ------- Skid Breakdown Function  --------------

  const handleOpenSkidBreakdown = (orderDetail) => {
    clearSession();

    skidBreakdown.OrderID = orderDetail.OrderID;
    skidBreakdown.OrderNumber = orderDetail.OrderNumber;
    skidBreakdown.ClientID = orderDetail.ClientID;

    skidBreakdown.IsOrderSkidBreakdown = orderDetail.IsOrderSkidBreakdown;
    skidBreakdown.IsOrderSkid = orderDetail.IsOrderSkid;
    skidBreakdown.TotalSkidWeight = "";
    skidBreakdown.TypeOrderSkidBreakdownModel = "";

    // if (orderDetail.IsOrderSkidBreakdown === true) {
    dispatch(
      orderActions.GetOrderSkidBreakDownID({ OrderID: orderDetail.OrderID })
    );
    // } else {
    //   skidBreakdown.TotalSkidWeight = "";
    //   skidBreakdown.TypeOrderSkidBreakdownModel = "";
    //   // skidBreakdownListData.SkidWeight = skidBreakdownListData.SkidDimensionHeight = skidBreakdownListData.SkidDimensionLength = skidBreakdownListData.SkidDimensionWeight = skidBreakdownListData.ImageBase64 = "";

    //   const ClearData = [
    //     {
    //       OrderSkidBreakdownID: 1,
    //       SkidWeight: "",
    //       SkidDimensionLength: "",
    //       SkidDimensionWeight: "",
    //       SkidDimensionHeight: "",
    //       ImageFilePath: "",
    //       SkidBoxNumbers: "",
    //       SkidIndex: 1,
    //     },
    //   ];
    //   setSkidBreakdownList(ClearData);
    // }
    setSkidBreakdown(skidBreakdown);

    setSkidBreakdownModal(true);
    setSubmitted(false);
    setIsDisabled(false);
  };

  useEffect(() => {
    if (skidBreakdownDetailsList && skidBreakdownDetailsList.OrderID > 0) {
      skidBreakdown.TotalSkidWeight = skidBreakdownDetailsList?.TotalSkidWeight;
      let skidBreakdownList = [
        ...skidBreakdownDetailsList?.TypeOrderSkidBreakdownModel,
      ];

      if (skidBreakdownList.length > 0) {
        setSkidBreakdown(skidBreakdown);
        setSkidBreakdownList(skidBreakdownList);
      } else {
        // skidBreakdownListData.SkidWeight = skidBreakdownListData.SkidDimensionHeight = skidBreakdownListData.SkidDimensionLength = skidBreakdownListData.SkidDimensionWeight = skidBreakdownListData.ImageBase64 = "";

        const ClearData = [
          {
            OrderSkidBreakdownID: 0,
            SkidWeight: "",
            SkidDimensionLength: "",
            SkidDimensionWeight: "",
            SkidDimensionHeight: "",
            ImageFilePath: "",
            SkidBoxNumbers: "",
            SkidIndex: 1,
            IsDeleted: false,
          },
        ];
        setSkidBreakdownList(ClearData);
      }
    }
  }, [skidBreakdownDetailsList]);

  // close popup
  const handleSkidBreakdownClosePopup = () => {
    setSkidBreakdownModal(false);
  };

  //Skid File upload Function
  const handleSkidFileChange = async (e, index) => {
    const data = [...skidBreakdownListData];
    const files = e.target.files;

    let file = files[0];
    if (file) {
      const fileType = file["type"];
      const validImageTypes = ["image/jpeg", "image/jpg", "image/png"];
      if (!validImageTypes.includes(fileType)) {
        Toastr("Invalid file format selected", "warning");
      } else {
        const MAX_FILE_SIZE = 11000; // 11MB
        const fileSizeKiloBytes = file.size / 1024;

        if (fileSizeKiloBytes > MAX_FILE_SIZE) {
          Toastr("File size is greater than maximum 10MB", "warning");
        } else {
          let base64 = await convertBase64(file);
          let formData = new FormData();
          formData.append("file", file);
          let row = { ...data[index] };
          if (row.OrderSkidBreakdownID > 0) {
            row.ImageBase64 = base64;
            data[index] = { ...row };
          } else {
            data[index].ImageBase64 = base64;
          }

          setSkidBreakdownList(data);
        }
      }
    }
  };

  // handle Change function
  const handleSkidBreakdownChange = (event, index) => {
    event.preventDefault();
    const regexDecimal = /^[+-]?((\d+(\.\d*)?)|(\.\d+))$/;
    const regexNumberAndComma = /^[0-9,\b]+$/;
    const regexNumber = /^[0-9\b]+$/;
    const nospecial = /^[a-zA-Z0-9]+$/;
    const fieldName = event.target.getAttribute("name");
    const fieldValue = event.target.value;
    let data = [...skidBreakdownListData];
    let row = { ...data[index] };
    if (fieldValue && fieldValue.trim()) {
      if (
        fieldName === "SkidWeight" ||
        fieldName === "SkidDimensionLength" ||
        fieldName === "SkidDimensionWeight" ||
        fieldName === "SkidDimensionHeight"
      ) {
        if (fieldValue === "" || regexDecimal.test(fieldValue)) {
          if (
            (!fieldValue.includes(".") && fieldValue.length <= 6) ||
            (fieldValue.includes(".") &&
              fieldValue.split(".")[0].length <= 6 &&
              fieldValue.split(".")[1].length <= 2)
          ) {
            row[fieldName] = fieldValue;
          }
        }
      } else if (fieldName === "SkidBoxNumbers") {
        if (fieldValue === "" || regexNumber.test(fieldValue)) {
          row[fieldName] = fieldValue;
        }
      }
    } else {
      row[fieldName] = fieldValue.trim();
    }
    data[index] = row;
    setSkidBreakdownList(data);

    skidBreakdown.TypeOrderSkidBreakdownModel = data;
    if (fieldName === "SkidWeight") {
      const sumTotalSkidWeight =
        skidBreakdown &&
        skidBreakdown.TypeOrderSkidBreakdownModel?.filter(
          (d) => d.IsDeleted === false
        ).reduce((accumulator, object) => {
          let SkidWeight = 0;
          if (object.SkidWeight) {
            SkidWeight = parseFloat(object.SkidWeight);
          }
          return parseFloat(accumulator) + SkidWeight;
        }, 0);
      skidBreakdown.TotalSkidWeight = sumTotalSkidWeight;
    } else if (fieldName === "SkidBoxNumbers") {
      const sumTotalSkidBoxNumbers =
        skidBreakdown &&
        skidBreakdown.TypeOrderSkidBreakdownModel?.filter(
          (d) => d.IsDeleted === false
        ).reduce((accumulator, object) => {
          let SkidBoxNumbers = 0;
          if (object.SkidBoxNumbers) {
            SkidBoxNumbers = parseFloat(object.SkidBoxNumbers);
          }
          return parseFloat(accumulator) + SkidBoxNumbers;
        }, 0);
      skidBreakdown.TypeOrderSkidBreakdownModel.SkidBoxNumbers =
        sumTotalSkidBoxNumbers;
    }
    setSkidBreakdown(skidBreakdown);
  };

  const handleAddSkid = () => {
    let filterskidBreakdownListData = skidBreakdownListData.filter(
      (d) => d.IsDeleted === false
    );

    const lastRow =
      filterskidBreakdownListData[filterskidBreakdownListData.length - 1];
    const newId = lastRow ? lastRow.SkidIndex + 1 : 0;
    if (filterskidBreakdownListData && filterskidBreakdownListData.length > 7) {
      Toastr("You can include a maximum of eight Skid Breakdown.", "warning");
    } else {
      skidBreakdownListData.push({
        OrderSkidBreakdownID: 0,
        SkidWeight: "",
        SkidDimensionLength: "",
        SkidDimensionWeight: "",
        SkidDimensionHeight: "",
        ImageFilePath: "",
        SkidIndex: newId,
        SkidBoxNumbers: "",
        IsDeleted: false,
      });
      setSkidBreakdownList(skidBreakdownListData);
    }
  };

  const handleDeleteSkid = (index, OrderSkidBreakdownID) => {
    let skidBreakdownData = { ...skidBreakdown };
    if (OrderSkidBreakdownID > 0) {
      let row = { ...skidBreakdownListData[index] };
      row.IsDeleted = true;
      skidBreakdownListData[index] = { ...row };
    } else {
      skidBreakdownListData.splice(index, 1);
    }
    setSkidBreakdownList(skidBreakdownListData);

    let sumTotalSkidWeight = 0;
    let sumTotalSkidBoxNumbers = 0;

    skidBreakdownListData
      ?.filter((d) => d.IsDeleted === false)
      .reduce((accumulator, object) => {
        let SkidWeight = object.SkidWeight ? parseFloat(object.SkidWeight) : 0;
        let SkidBoxNumbers = object.SkidBoxNumbers
          ? parseFloat(object.SkidBoxNumbers)
          : 0;

        sumTotalSkidWeight += SkidWeight;
        sumTotalSkidBoxNumbers += SkidBoxNumbers;
        return accumulator; // returning accumulator here, though not really needed in this case
      }, 0);

    skidBreakdownData.TotalSkidWeight = sumTotalSkidWeight;
    skidBreakdownData.SkidBoxNumbers = sumTotalSkidBoxNumbers;

    setSkidBreakdown(skidBreakdownData);
  };

  // Submit data function
  const handleSubmitSkid = (event) => {
    let skidBreakdownDate = { ...skidBreakdown };
    let IsValid = false;

    if (
      skidBreakdownListData &&
      skidBreakdownListData.filter((d) => d.IsDeleted === false).length > 0
    ) {
      skidBreakdownListData
        .filter((d) => d.IsDeleted === false)
        .forEach(function (item) {
          if (
            !item.SkidWeight ||
            item.SkidWeight <= 0 ||
            !item.SkidDimensionLength ||
            item.SkidDimensionLength <= 0 ||
            !item.SkidDimensionWeight ||
            item.SkidDimensionWeight <= 0 ||
            !item.SkidDimensionHeight ||
            item.SkidDimensionHeight <= 0 ||
            !item.SkidBoxNumbers ||
            item.SkidBoxNumbers <= 0
          ) {
            IsValid = true;
          }
        });

      //  }
      if (!IsValid) {
        showLoader();
        // let Param = { OrderID: skidBreakdownDate.OrderID };
        // CommonService.GetOrderBoxCount(Param).then((response) => {
        // let TotalBoxCount = response.data;
        // if (
        //   TotalBoxCount ===
        //   parseInt(skidBreakdown.TypeOrderSkidBreakdownModel.SkidBoxNumbers)
        // ) {
        setIsDisabled(true);
        skidBreakdownDate.TypeOrderSkidBreakdownModel = skidBreakdownListData;
        dispatch(orderActions.GetSkidBreakdownDetails(skidBreakdownDate))
          .then((response) => {
            if (response.type === "order/GetSkidBreakdownDetails/fulfilled") {
              if (response.payload === 1) {
                hideLoader();
                setIsDisabled(false);
              } else {
                Toastr("Error occurred while adding skid.", "warning");
              }
            } else {
              Toastr("Failed to fetch skid breakdown details.", "warning");
            }
          })
          .catch((error) => {
            console.error("API call failed:", error);
            Toastr("Network error or server issue.", "warning");
          })
          .finally(() => hideLoader());
        setIsDisabled(false);
        // hideLoader();
        // } else {
        //Toastr('Box Mismatch', 'warning');
        // Toastr(
        //   "Incorrect box quantity,Please enter correct value " +
        //     TotalBoxCount +
        //     " boxes number",
        //   "warning"
        // );
        // }
        // });
      } else {
        hideLoader();
        setSubmitted(true);

        Toastr("Please fill in the required missing fields", "warning");
      }
    } else {
      hideLoader();
      setSubmitted(true);
      Toastr("Please add atleast one Skid BreakDown", "warning");
    }
  };

  const handleRevokeSkid = (event) => {
    dispatch(orderActions.revokeSkidBreakdown(skidBreakdown.OrderID)).then(
      (response) => {
        if (response?.type === "order/revokeSkidBreakdown/fulfilled") {
          if (response?.payload === 1) {
            setSkidBreakdownModal(false);
            Toastr("Skid Breakdown Revoke", "success");
            dispatch(
              orderActions.GetOrderList({
                OrderID: 0,
                ClientID: 0,
                Status: 1,
                UserID: currentUser.Id,
                UserTypeID: currentUser.UserTypeID,
              })
            );
          } else {
            Toastr("Skid Breakdown Revoke error", "warning");
          }
        }
      }
    );
  };

  // #endregion ------ Skid Breakdown Function --------------

  // #region ------- Order Reversed Function  --------------
  const handleOpenOrderReversed = (orderDetail) => {
    setOrderReversedModal(true);
    orderCurrentRow.current.value = orderDetail;
    dispatch(
      orderActions.GetOrderDetailsByID({ OrderID: orderDetail.OrderID })
    );
  };

  const handleRowSelection = (rows) => {
    setSelectedRows((prevRows) => {
      if (JSON.stringify(prevRows) !== JSON.stringify(rows)) {
        console.log("Updated Selected Rows:", rows);
        return rows;
      }
      return prevRows;
    });
  };

  const handleOrderReversed = () => {
    showLoader();
    const productIDList = selectedRows.map((item) => item.ProductID).join(",");
    if (productIDList.length > 0) {
      CommonService.CheckQuickBookConnection().then((r) => {
        if (
          r?.data?.IsRefreshTokenExpired === true &&
          r?.data?.QuickBooksRefreshToken
        ) {
          // Call the service to update QuickBooks with the order data
          CommonService.GetProductCurrentQuantity({
            ProductIDList: productIDList,
          }).then((res) => {
            // Check if the response contains data
            if (res.data) {
              let currentQuantitys = res.data;
              // If the response output indicates success
              let gemar_data = [];
              let PD_data = [];
              let TypeOrderProductModel = [];
              let pageStatus = "OrderReversed";

              selectedRows.map((item) => {
                let rowProduct = currentQuantitys.find(
                  (d) => d.ProductID === parseInt(item.ProductID)
                );

                let lastQuantity =
                  parseInt(item.Quantity) + parseInt(rowProduct.Quantity);

                if (item.IsGemar === true) {
                  let data = {
                    id: item.WCProductID,
                    stock_quantity: lastQuantity,
                  };
                  gemar_data.push(data);
                }

                if (item.IsPartyDeco === true) {
                  let data = {
                    id: item.PDWCProductID,
                    stock_quantity: lastQuantity,
                  };
                  PD_data.push(data);
                }

                let OrderProductdata = {
                  OrderProductID: item.OrderProductID,
                  ProductName: item.ProductName,
                  ProductID: item.ProductID,
                  Quantity: item.Quantity,
                  UnitPrice: item.UnitPrice,
                  Total: item.Total,
                };

                TypeOrderProductModel.push(OrderProductdata);
              });

              typeOrderProductModelRef.current.value = TypeOrderProductModel;

              if (
                gemar_data &&
                gemar_data.length > 0 &&
                PD_data &&
                PD_data.length > 0
              ) {
                AddUpdateOrder_GemarAndPD(gemar_data, PD_data, pageStatus);
              } else if (gemar_data && gemar_data.length > 0) {
                AddUpdateOrder_Gemar(gemar_data, pageStatus);
              } else if (PD_data && PD_data.length > 0) {
                AddUpdateOrder_PD(PD_data, pageStatus);
              } else {
                hideLoader();
              }
            }
          });
        } else {
          Toastr("Please connect to QuickBooks.", "warning");
          hideLoader();
        }
      });
    } else {
      Toastr("Please select any one checkbox.", "warning");
      hideLoader();
    }
  };

  const updateOrderReversed = () => {
    let typeOrderProductModelList = [...typeOrderProductModelRef.current.value];
    let orderDetail = { ...orderCurrentRow.current.value };
    const totalSum = typeOrderProductModelList.reduce(
      (sum, item) => sum + parseFloat(item.Total),
      0
    );

    let OrderIDVal = orderDetail?.OrderID;
    let ClientEmailID = orderDetail?.ClientEmailID;
    let OrderNumber = orderDetail?.OrderNumber;

    let OrderModel = {
      OrderID: OrderIDVal,
      CreatedBy: currentUser.Id,
      OrderNumber: OrderNumber,
      ReversedAmount: totalSum.toFixed(2),
      ClientEmailID: ClientEmailID,
      OrderProductModelList: typeOrderProductModelList,
    };

    dispatch(orderActions.updateOrderReversed(OrderModel)).then((response) => {
      if (response?.type === "order/updateOrderReversed/fulfilled") {
        if (response?.payload === 1) {
          hideLoader();
          Toastr("Order Reversed successfully updated", "success");
          dispatch(
            orderActions.GetOrderList({
              OrderID: 0,
              ClientID: 0,
              Status: 1,
              UserID: currentUser.Id,
              UserTypeID: currentUser.UserTypeID,
            })
          );
        } else {
          Toastr("Order Reversed error", "warning");
          hideLoader();
        }
      }
    });
  };

  // #endregion ------ Order ReversedFunction --------------

  return (
    <>
      <PageTitle activeMenu="Order List" motherMenu="Order" />
      <ToastContainer />
      <div className="card">
        <div className="card-header">
          <h4 className="card-title header-title">Order List</h4>
          <div className="float-sm-end">
            <Button
              className="me-2"
              variant="danger btn-rounded"
              onClick={handleClickPDF}
            >
              <span className="btn-icon-start text-danger">
                <i className="fa fa-solid fa-file-pdf"></i>
                {/* <i className="fa fa-regular fa-file-excel"></i> */}
              </span>
              PDF
            </Button>
            <Button
              className="me-2"
              variant="secondary btn-rounded"
              onClick={handleClickExcel}
            >
              <span className="btn-icon-start text-secondary">
                {/* <i className="fa fa-solid fa-file-pdf"></i> */}
                <i className="fa fa-regular fa-file-excel"></i>
              </span>
              Excel
            </Button>
            {(currentUser.UserTypeID === 1 ||
              currentUser.UserTypeID === 2 ||
              currentUser.UserTypeID === 8) && (
              <>
                <Button
                  className="me-2"
                  variant="primary btn-rounded"
                  onClick={() => handleAddOrder()}
                >
                  <span className="btn-icon-start text-primary">
                    <i className="fa fa-plus color-info" />
                  </span>
                  Add
                </Button>
                {/* {(settingResponse?.IsRefreshTokenExpired === false) && */}
                <Button
                  className="me-2"
                  variant="secondary btn-rounded"
                  onClick={() => handleConnectQuickBook()}
                >
                  <span className="btn-icon-start text-secondary">qb</span>
                  Connect QuickBooks
                </Button>
                {/* } */}
              </>
            )}
          </div>
        </div>
        <div className="card-body">
          <OrderTable
            columns={columns}
            data={orderList}
            getFilterValue={(id) => handleGetFilter(id)}
            onDataUpdate={handleTableDataUpdate}
          />
        </div>
      </div>
      <Modal
        className="fade bd-example-modal-lg"
        show={isOrderAssignModal}
        size="lg"
      >
        <Modal.Header>
          <Modal.Title>Order Assign</Modal.Title>
          <Button
            variant=""
            className="btn-close"
            // onClick={() => setAllocationModal(false)}
            onClick={() => handleClosePopup()}
          ></Button>
        </Modal.Header>
        <Modal.Body>
          <form>
            <div className="row">
              <div className="col-md-6 mb-3">
                <label className="text-black font-w500">
                  Assign to Warehouse<span className="text-danger">*</span>
                </label>
                <div className="contact-name">
                  <Select
                    classNamePrefix={"custom_select_css"}
                    name="WareHouseID"
                    value={orderAssignData.WarehouseAssignOption}
                    options={warehouseDrpList}
                    onChange={(event) =>
                      handleOrderAssignDrpChange(event, "WareHouseID")
                    }
                    styles={
                      submitted && orderAssignData.WareHouseID === 0
                        ? styles
                        : ""
                    }
                    isDisabled={
                      orderAssignData.OrderStatusID >=
                      enumOrderStatus.OrderPrepared
                        ? true
                        : false
                    }
                  />

                  <span className="validation-text"></span>
                </div>
              </div>
              <div className="col-md-6 mb-3">
                <label className="text-black font-w500">
                  Assign to Prepper<span className="text-danger">*</span>
                </label>
                <div className="contact-name">
                  <Select
                    classNamePrefix={"custom_select_css"}
                    name="AssigntoPrepper"
                    value={orderAssignData.PrepperOption}
                    options={prepperDrpList}
                    onChange={(event) =>
                      handleOrderAssignDrpChange(event, "AssignedPrepperID")
                    }
                    styles={
                      submitted && orderAssignData.AssignedPrepperID === 0
                        ? styles
                        : ""
                    }
                    isDisabled={
                      orderAssignData.OrderStatusID >=
                      enumOrderStatus.OrderPrepared
                        ? true
                        : false
                    }
                    // className={`form-control ${newFormData.UserID > 0 ? 'readonly_css' : ''} ${(submitted && !newFormData.EmailID) && 'border-danger'}`}
                  />

                  <span className="validation-text"></span>
                </div>
              </div>
              <div className="col-md-6 mb-3">
                <label className="text-black font-w500">
                  Assign to Dispatcher<span className="text-danger">*</span>
                </label>
                <div className="contact-name">
                  <Select
                    classNamePrefix={"custom_select_css"}
                    name="AssigntoPrepper"
                    value={orderAssignData.DispatcherOption}
                    options={dispatcherDrpList}
                    onChange={(event) =>
                      handleOrderAssignDrpChange(event, "AssignedDispatcherID")
                    }
                    styles={
                      submitted && orderAssignData.AssignedDispatcherID === 0
                        ? styles
                        : ""
                    }
                    isDisabled={
                      orderAssignData.OrderStatusID >=
                      enumOrderStatus.ReadyToDispatch
                        ? true
                        : false
                    }
                  />

                  <span className="validation-text"></span>
                </div>
              </div>
            </div>
          </form>
        </Modal.Body>

        <Modal.Footer>
          <Button variant="danger light" onClick={() => handleClosePopup()}>
            Cancel
          </Button>
          {orderAssignData.OrderStatusID < enumOrderStatus.ReadyToDispatch && (
            <Button
              variant=""
              // onClick={() => setLargeModal(false)}
              onClick={handleAssignSubmit}
              className="btn btn-primary"
            >
              Submit
            </Button>
          )}
        </Modal.Footer>
      </Modal>

      <Modal className="fade bd-example-modal-lg" show={isOpenModal} size="lg">
        <Modal.Header>
          <Modal.Title>Change Order Status</Modal.Title>
          <Button
            variant=""
            className="btn-close"
            onClick={() => handleClosePopup()}
          ></Button>
        </Modal.Header>
        <Modal.Body>
          <form>
            <div className="row">
              <div className="col-md-6 mb-3">
                <label className="text-black font-w500">Order ID</label>
                <div className="contact-name">
                  <input
                    type="text"
                    className={`form-control readonly_css '} `}
                    name="OrderNumber"
                    value={newFormData.OrderNumber}
                    placeholder="OrderNumber"
                  />

                  <span className="validation-text"></span>
                </div>
              </div>

              <div className="col-md-6 mb-3">
                <label className="text-black font-w500">
                  Order Status<span className="text-danger">*</span>
                </label>
                <div className="contact-name">
                  <Select
                    classNamePrefix={"custom_select_css"}
                    name="OrderStatusID"
                    value={newFormData.OrderStatusOptions}
                    onChange={(event) =>
                      handleChangeStatusDrpChange(event, "OrderStatusID")
                    }
                    options={orderStatusList}
                    styles={
                      submitted && !newFormData.OrderStatusOptions ? styles : ""
                    }
                  />

                  <span className="validation-text"></span>
                </div>
              </div>
            </div>
          </form>
        </Modal.Body>

        <Modal.Footer>
          <Button variant="danger light" onClick={() => setOpenModal(false)}>
            Cancel
          </Button>
          <Button
            variant=""
            onClick={changeOrderStatusSubmit}
            // onClick={handleAddFormSubmit}
            className="btn btn-primary"
          >
            Submit
          </Button>
        </Modal.Footer>
      </Modal>

      {/* <Modal
        className="fade bd-example-modal-lg"
        show={isCancelModal}
        size="md"
      >
        <Modal.Header>
          <Modal.Title>Order Cancel Reason</Modal.Title>
          <Button
            variant=""
            className="btn-close"
            onClick={() => handleClosePopup()}
          ></Button>
        </Modal.Header>
        <Modal.Body>
          <form>
            <div className="row">
              <div className="col-md-12 mb-6">
                <label className="text-black font-w500">
                  Reason <span className="text-danger">*</span>
                </label>
                <div className="contact-name">
                  <input
                    type="text"
                    className={`form-control ${
                      submitted &&
                      !newFormData.CancelledReason &&
                      "border-danger"
                    }`}
                    name="CancelledReason"
                    required="required"
                    onChange={handleChange}
                    //value={newFormData.CancelledReason}
                    placeholder="Reason"
                    maxLength={50}
                  />
                  <span className="validation-text"></span>
                </div>
              </div>
            </div>
          </form>
        </Modal.Body>

        <Modal.Footer>
          <Button variant="danger light" onClick={() => setCancelModal(false)}>
            Close
          </Button>
          <Button
            variant=""
            onClick={handleCancelSubmit}
            // onClick={handleAddFormSubmit}
            className="btn btn-primary"
          >
            Submit
          </Button>
        </Modal.Footer>
      </Modal> */}

<Modal
  className="fade bd-example-modal-lg"
  show={isCancelModal}
  size="md"
>
  <Modal.Header>
    <Modal.Title>
      {selectedCancelOrder &&
      selectedCancelOrder.OrderStatusID >= 4 &&
      selectedCancelOrder.OrderStatusID !== 8 &&
      !cancelAuthorization.isAdminPasscodeValid
        ? "Admin Authorization Required"
        : "Order Cancel Reason"}
    </Modal.Title>
    <Button
      variant=""
      className="btn-close"
      onClick={() => handleClosePopup()}
    ></Button>
  </Modal.Header>
  <Modal.Body>
    <form>
      <div className="row">
        {(() => {
          const requiresAdminAuth =
            selectedCancelOrder &&
            selectedCancelOrder.OrderStatusID >= 4 &&
            selectedCancelOrder.OrderStatusID !== 8;

          // ---- STEP 1: Admin Password (only when required and not yet verified) ----
          if (requiresAdminAuth && !cancelAuthorization.isAdminPasscodeValid) {
            return (
              <div className="col-md-12 mb-6">
                <label className="text-black font-w500">
                  Admin Passcode <span className="text-danger">*</span>
                </label>
                <div className="contact-name">
                  <div className="input-group mb-3">
                    <input
                      type={isRevealPwd ? "text" : "password"}
                      maxLength="10"
                      className={`form-control ${
                        submitted &&
                        !cancelAuthorization.AdminPasscode &&
                        "border-danger"
                      }`}
                      name="AdminPasscode"
                      value={cancelAuthorization.AdminPasscode}
                      onChange={handleAdminPasswordChange}
                      placeholder="Admin Passcode"
                    />
                    <span className="input-group-text togglePassword">
                      <i
                        title={isRevealPwd ? "Hide" : "Show"}
                        className={
                          isRevealPwd
                            ? "fa fa-eye-slash PasswordHideShow"
                            : "fa fa-eye PasswordHideShow"
                        }
                        onClick={() => setIsRevealPwd(!isRevealPwd)}
                      />
                    </span>
                  </div>
                  <span className="validation-text"></span>
                </div>
              </div>
            );
          }

          // ---- STEP 2: Cancel Reason (default flow, or after admin passcode verified) ----
          return (
            <div className="col-md-12 mb-6">
              <label className="text-black font-w500">
                Reason <span className="text-danger">*</span>
              </label>
              <div className="contact-name">
                <input
                  type="text"
                  className={`form-control ${
                    submitted &&
                    !addFormData.CancelledReason &&
                    "border-danger"
                  }`}
                  name="CancelledReason"
                  required="required"
                  onChange={handleChange}
                  //value={newFormData.CancelledReason}
                  placeholder="Reason"
                  maxLength={50}
                />
                <span className="validation-text"></span>
              </div>
            </div>
          );
        })()}
      </div>
    </form>
  </Modal.Body>

  <Modal.Footer>
    <Button variant="danger light" onClick={() => handleClosePopup()}>
      Close
    </Button>
    {(() => {
      const requiresAdminAuth =
        selectedCancelOrder &&
        selectedCancelOrder.OrderStatusID >= 4 &&
        selectedCancelOrder.OrderStatusID !== 8;

      if (requiresAdminAuth && !cancelAuthorization.isAdminPasscodeValid) {
        return (
          <Button
            variant=""
            onClick={handleVerifyAdminPasscode}
            className="btn btn-primary"
          >
            Verify
          </Button>
        );
      }

      return (
        <Button
          variant=""
          onClick={handleCancelSubmit}
          className="btn btn-primary"
        >
          Submit
        </Button>
      );
    })()}
  </Modal.Footer>
</Modal>



      {/* courier modal */}
      <Modal
        className="fade bd-example-modal-lg"
        show={isCourierModal}
        size="md"
      >
        <Modal.Header>
          <Modal.Title>{`Order Courier Details - ${courierModalDetails?.OrderNumber}`}</Modal.Title>
          <Button
            variant=""
            className="btn-close"
            onClick={() => handleCloseCourierPopup()}
          ></Button>
        </Modal.Header>
        <Modal.Body>
          <form>
            <div className="row">
              <div className="col-md-12">
                <label className="text-black font-w700">
                  Courier<span className="text-danger">*</span>
                </label>
                <Select
                  classNamePrefix={"custom_select_css"}
                  name="AdminCourierTypeID"
                  options={courierTypeDrpList}
                  onChange={(event) =>
                    handleCourierTypeDrpChange(event, "AdminCourierTypeID")
                  }
                  isDisabled={courierModalDetails?.OrderStatusID > 3}
                  value={courierDetails?.CourierTypeOptions}
                  // styles={
                  //   submitted && !courierDetails.AdminCourierTypeID
                  //     ? styles
                  //     : ""
                  // }
                />
              </div>
              {courierDetails?.CourierTypeOptions?.label &&
                Number(courierDetails?.CourierTypeOptions?.IsSkipBoL) === 0 && (
                  <>
                    <div className="col-md-12 mt-5">
                      <label className="text-black font-w700">
                        Bill of Lading upload
                        <span className="text-danger">*</span>
                      </label>
                      <div className="input-group mb-3">
                        <div className="form-file">
                          {courierModalDetails?.OrderStatusID < 4 && (
                            <input
                              type="file"
                              onChange={(event) => uploadLadingImg(event)}
                              name="bill_img"
                              className={`custom-file-input form-control ${submitted}`}
                              accept="image/jpeg"
                              // styles={
                              //   submitted && courierDetails.AdminBillFilePath === ""
                              //     ? styles
                              //     : ""
                              // }
                            />
                          )}
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      {courierDetails.ImageBase64 ||
                      courierDetails.AdminBillFilePath ? (
                        <img
                          style={{ height: "170px" }}
                          className="card-img-top"
                          src={
                            !courierDetails.ImageBase64
                              ? REACT_APP_API_IMAGE_URL +
                                courierDetails.AdminBillFilePath
                              : courierDetails.ImageBase64
                          }
                          alt="Card image cap"
                        />
                      ) : (
                        <img
                          style={{ height: "170px" }}
                          className="card-img-top"
                          src={emptyImage}
                          alt="Card image cap"
                        />
                      )}
                    </div>
                  </>
                )}
            </div>
          </form>
        </Modal.Body>

        <Modal.Footer>
          <Button
            variant="danger light"
            onClick={() => handleCloseCourierPopup()}
          >
            Close
          </Button>
          {courierModalDetails?.OrderStatusID < 4 && (
            <Button
              variant=""
              onClick={handleCourierDetailsSubmit}
              className="btn btn-primary"
            >
              Submit
            </Button>
          )}
        </Modal.Footer>
      </Modal>

      <Modal
        className="fade bd-example-modal-lg"
        show={isPaymentModal}
        size="lg"
      >
        <Modal.Header>
          <Modal.Title>Payment Transaction</Modal.Title>
          <Button
            variant=""
            className="btn-close"
            onClick={() => handleClosePopup()}
          ></Button>
        </Modal.Header>
        <Modal.Body>
          <form>
            <div className="row">
              <div className="col-md-6 mb-3">
                <label className="text-black font-w500">
                  Payment Type<span className="text-danger">*</span>
                </label>
                <div className="contact-name">
                  <Select
                    classNamePrefix={"custom_select_css"}
                    name="PaymentTypeID"
                    value={newAddPaymentData.PaymentTypeOption}
                    options={paymentTypeDrpList}
                    isDisabled={newAddPaymentData.IsNoPayment}
                    onChange={(event) =>
                      handleDrpPayTransChange(event, "PaymentTypeID")
                    }
                    styles={
                      submitted &&
                      ((currentUser.UserTypeID === 1 &&
                        (newAddPaymentData.IsNoPayment === false ||
                          !newAddPaymentData.IsNoPayment) &&
                        (!newAddPaymentData.PaymentTypeID ||
                          newAddPaymentData.PaymentTypeID === 0)) ||
                        (currentUser.UserTypeID === 2 &&
                          (!newAddPaymentData.PaymentTypeID ||
                            newAddPaymentData.PaymentTypeID === 0)))
                        ? styles
                        : ""
                    }
                  />

                  <span className="validation-text"></span>
                </div>
              </div>
              <div className="col-md-6 mb-3">
                <label className="text-black font-w500">
                  Payment Amount
                  {newAddPaymentData.PaymentTypeID !== 8 &&
                    !newAddPaymentData.IsNoPayment && (
                      <span className="text-danger">*</span>
                    )}
                </label>

                <input
                  type="text"
                  className={`form-control ${
                    newAddPaymentData.IsNoPayment ? "readonly_css" : ""
                  } ${
                    submitted &&
                    ((currentUser.UserTypeID === 1 &&
                      (newAddPaymentData.IsNoPayment === false ||
                        !newAddPaymentData.IsNoPayment) &&
                      (!newAddPaymentData.PaymentAmount ||
                        newAddPaymentData.PaymentAmount === "$0.00" ||
                        (newAddPaymentData.PaymentAmount &&
                          parseInt(newAddPaymentData.PaymentAmount) >
                            parseInt(newAddPaymentData.GrandTotal)))) ||
                      (currentUser.UserTypeID === 2 &&
                        (!newAddPaymentData.PaymentAmount ||
                          parseInt(newAddPaymentData.PaymentAmount) === 0 ||
                          (newAddPaymentData.PaymentAmount &&
                            parseInt(newAddPaymentData.PaymentAmount) >
                              parseInt(newAddPaymentData.GrandTotal))))) &&
                    " border-danger"
                  }`}
                  autocomplete="off"
                  name="PaymentAmount"
                  // required="required"
                  required={
                    newAddPaymentData.PaymentTypeID !== 8 &&
                    !newAddPaymentData.IsNoPayment
                  }
                  onBlur={(e) => handleBlur(e)}
                  onChange={(e) => handlePaymentTransChange(e)}
                  value={newAddPaymentData.PaymentAmount}
                  readOnly={newAddPaymentData.IsNoPayment}
                  placeholder="Payment Amount "
                />

                <span className="validation-text"></span>
              </div>
            </div>

            <div className="row">
              {newAddPaymentData.PaymentTypeID === 3 && (
                <div className="col-md-6 mb-3">
                  <label className="text-black font-w500">
                    Check Number <span className="text-danger">*</span>
                  </label>
                  <div className="contact-name">
                    <input
                      type="text"
                      className={`form-control ${
                        submitted &&
                        !newAddPaymentData.CheckNumber &&
                        "border-danger"
                      }`}
                      name="CheckNumber"
                      required="required"
                      value={newAddPaymentData.CheckNumber}
                      onChange={handlePaymentTransChange}
                      placeholder="Check Number"
                    />

                    <span className="validation-text"></span>
                  </div>
                </div>
              )}

              <div className="col-md-6 mb-3">
                <label className="text-black font-w500"> Payment Status</label>
                <div className="contact-name">
                  <Select
                    name="PaymentStatusID"
                    classNamePrefix={"custom_select_css"}
                    value={newAddPaymentData.PaymentStatusOption}
                    //  options={newAddPaymentData.PaymentStatusID}
                    // placeholder="Paid"
                    isDisabled={true}
                  />

                  <span className="validation-text"></span>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-6 mb-3">
                <label className="text-black font-w500">
                  Upload/Add Image(jpeg/jpg/png)
                </label>

                <div className="col-md-9 mb-3">
                  {newAddPaymentData.ImageFilePath ||
                  newAddPaymentData.ImageBase64 ? (
                    <>
                      <Fragment>
                        <div className="card">
                          <div className="card-header">
                            <span className="float-right">
                              {" "}
                              <i
                                onClick={() => handleClickImageClose()}
                                className="fas fa-times productImageClose"
                              ></i>
                            </span>
                          </div>

                          <img
                            style={{ height: "170px" }}
                            className="card-img-bottom img-fluid "
                            src={newAddPaymentData.ImageBase64}
                            alt="Card_image_cap"
                          />
                        </div>
                      </Fragment>
                    </>
                  ) : (
                    <div className="card">
                      {newAddPaymentData.ImageFilePath ||
                      newAddPaymentData.ImageBase64 ? (
                        <img
                          style={{ height: "170px" }}
                          className="card-img-top"
                          src={newAddPaymentData.ImageBase64}
                          alt="Card image cap"
                        />
                      ) : (
                        <img
                          style={{ height: "170px" }}
                          className="card-img-top"
                          src={emptyImage}
                          alt="Card image cap"
                        />
                      )}
                    </div>
                  )}
                </div>

                <div className="input-group mb-3">
                  <div className="form-file">
                    <input
                      type="file"
                      ref={inputRef}
                      onChange={(event) => UploadImages(event)}
                      className={`form-control `}
                    />
                  </div>
                  <span className="input-group-text">Upload</span>
                </div>
              </div>
            </div>
            {currentUser.UserTypeID === 1 && (
              <div className="row">
                <div className="form-group mb-3 col-md-12">
                  <label className="text-black font-w500 me-3"> </label>
                  <input
                    type="checkbox"
                    className="form-check-input"
                    checked={newAddPaymentData.IsNoPayment}
                    onChange={handleCheckNoPayment}
                    id="customCheckBox1"
                  />
                  <label
                    className="form-check-label text-black font-w500"
                    htmlFor="customCheckBox1"
                  >
                    No Payment
                  </label>
                </div>
              </div>
            )}
          </form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="danger light" onClick={() => handleClosePopup()}>
            Cancel
          </Button>
          <Button
            variant=""
            // onClick={() => setPaymentModal(false)}
            onClick={handlePaymentSubmit}
            className="btn btn-primary"
          >
            Submit
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal className="fade bd-example-modal-lg" show={isLabelModal} size="lg">
        <Modal.Header>
          <Modal.Title>Print Label</Modal.Title>
          <Button
            variant=""
            className="btn-close"
            onClick={() => handleClosePopup()}
          ></Button>
        </Modal.Header>
        <Modal.Body>
          <div className="row">
            {/* <div className="col-md-6 mb-4">
                            <label className="text-black font-w500 filtercss"> Order Product</label>
                            <div className="contact-name">
                                <Select
                                    classNamePrefix={"custom_select_css"}
                                    // onChange={(event) => handleTermDrpChange(event, index, inputField.AttributeID, inputField.ProductAttributeID)}
                                    //  value={OrderProductDrpList}
                                    isMulti
                                    options={OrderProductDrpList}
                                />
                                <span className="validation-text"></span>
                            </div>
                        </div> */}
            <div className="col-md-6 mb-4">
              <label className="text-black font-w500 filtercss"> Box # </label>
              <div className="contact-name">
                <Select
                  classNamePrefix={"custom_select_css"}
                  // onChange={(event) => handleTermDrpChange(event, index, inputField.AttributeID, inputField.ProductAttributeID)}
                  //  value={inputField.ProductTermOptionList}
                  onChange={(event) => handleBoxChange(event)}
                  isMulti
                  options={boxNumberDrpList}
                  value={optionSelected}
                  isSelectAll={true}
                  closeMenuOnSelect={false}
                  deleteRemoves={false}
                  disable={true}
                  isSearchable={false}
                  isClearable={false}
                  backspaceRemoves={true}
                />
                <span className="validation-text"></span>
              </div>
            </div>

            <div className="col-md-6 mb-4">
              <div className="BoxLabelPrint">
                <Button
                  className="me-2"
                  variant="primary btn-rounded"
                  onClick={() => handleSearch()}
                >
                  Search
                </Button>
                <Button
                  className="me-2"
                  variant="danger btn-rounded"
                  onClick={() => handleClear()}
                >
                  Clear
                </Button>
              </div>
            </div>

            {/* <div className="text-center">
                                <Button className="me-2" variant="primary btn-rounded" onClick={() => handleSearch()} >
                                    Search
                                </Button>
                                <Button className="me-2" variant="danger btn-rounded"
                                // onClick={() => handleClear()}
                                >
                                    Clear
                                </Button>
                            </div> */}
          </div>
          <br />
          <br />
          <div className="row">
            <div className="col-md-12 mb-6" style={{ textAlign: "center" }}>
              <div
                className="col-md-2 boxnumber"
                style={
                  isorderLable
                    ? { display: "inline-block" }
                    : { display: "none" }
                }
              >
                <label className="text-black font-w500">Print all boxes</label>
              </div>
            </div>
          </div>
          {/* <form ref={componentRef}> */}

          {/* ---#region Box Form --- */}
          <form>
            <div className="row">
              <div className="col-md-12 mb-4 d-flex flex-wrap">
                {ColumnOrderdata &&
                  ColumnOrderdata.length > 0 &&
                  ColumnOrderdata.map((inputField) => (
                    <div
                      className="boxnumber"
                      style={
                        isordervalues
                          ? { display: "inline-block" }
                          : { display: "none" }
                      }
                    >
                      <label className="text-black font-w800">Gemar USA</label>
                      <br></br>
                      <div>
                        <label className="text-black font-w500">
                          Client: {ClientName}
                        </label>
                      </div>

                      <label className="text-black font-w500">
                        Box #: {inputField.value} of {inputField.MaxBoxNumber}
                      </label>

                      <div>
                        <label className="text-black font-w500">
                          Weight: {inputField.TotalWeight} lbs
                        </label>
                      </div>

                      <div>
                        <label className="text-black font-w500">
                          Order #: {OrderNo}
                        </label>
                      </div>
                    </div>
                  ))}
              </div>
            </div>
          </form>
          {/* ---#endregion Box Form --- */}

          {/* ---#region Print View Box Form --- */}
          <div
            ref={componentRef}
            style={isPrintData ? { display: "block" } : { display: "none" }}
          >
            {ColumnOrderdata &&
              ColumnOrderdata.length > 0 &&
              ColumnOrderdata.map((inputField, index) => (
                <div
                  key={index}
                  className="print-label"
                  style={{
                    width: "288px", // 3in
                    height: "288px", // 3in
                    padding: "10px",
                    boxSizing: "border-box",
                    pageBreakAfter: "always",
                  }}
                >
                  <label className="text-black font-w800">Gemar USA</label>
                  <br />
                  <label className="text-black font-w500">
                    Client: {ClientName}
                  </label>
                  <br />
                  <label className="text-black font-w500">
                    Box #: {inputField.value} of {inputField.MaxBoxNumber}
                  </label>
                  <br />
                  <label className="text-black font-w500">
                    Weight: {inputField.TotalWeight} lbs
                  </label>
                  <br />
                  <label className="text-black font-w500">
                    Order #: {OrderNo}
                  </label>
                </div>
              ))}
          </div>
          {/* ---#endregion Print View Box Form --- */}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="danger light" onClick={() => handleClosePopup()}>
            Cancel
          </Button>
          <Button
            variant=""
            onClick={handlePrintShow}
            className="btn btn-primary"
          >
            Print
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal
        className="fade bd-example-modal-xl"
        show={isSkidBreakdownModal}
        size="xl"
      >
        <Modal.Header>
          <Modal.Title>
            {skidBreakdown.IsOrderSkidBreakdown === false
              ? "Skid Breakdown"
              : "View Skid Breakdown"}{" "}
            {" - Order ID : " + skidBreakdown.OrderNumber}
          </Modal.Title>
          <Button
            variant=""
            className="btn-close"
            onClick={() => handleClosePopup()}
          ></Button>
        </Modal.Header>
        <Modal.Body>
          {skidBreakdown && skidBreakdown.IsOrderSkidBreakdown === false && (
            <Button
              className="me-2 float-end postion-absolute-right"
              variant="primary btn-rounded"
              // title="Add SKID"
              onClick={() => handleAddSkid()}
            >
              <span className="btn-icon-start text-primary">
                <i className="fa fa-plus color-info" />
              </span>
              Add
            </Button>
          )}

          <div className="card-body">
            <div className="col-12">
              <div className="table-responsive">
                <div id="job_data" className="dataTables_wrapper">
                  <table
                    className="display w-100 dataTable "
                    id="example5"
                    role="grid"
                    aria-describedby="example5_info"
                  >
                    <thead>
                      <tr>
                        <th
                          rowSpan="2"
                          style={{
                            verticalAlign: "middle",
                            textAlign: "center",
                          }}
                        >
                          Skid #
                        </th>
                        <th
                          rowSpan="2"
                          style={{
                            verticalAlign: "middle",
                            textAlign: "center",
                          }}
                        >
                          Skid Weight
                        </th>
                        <th
                          colSpan="3"
                          style={{
                            verticalAlign: "middle",
                            textAlign: "center",
                            width: "50%",
                          }}
                        >
                          Skid Dimensions
                        </th>
                        <th
                          rowSpan="2"
                          style={{
                            verticalAlign: "middle",
                            textAlign: "center",
                          }}
                        >
                          Box #
                        </th>
                        <th
                          rowSpan="2"
                          style={{
                            verticalAlign: "middle",
                            textAlign: "center",
                          }}
                        >
                          Image upload
                        </th>
                        {skidBreakdown &&
                          skidBreakdown.IsOrderSkidBreakdown === false && (
                            <th
                              rowSpan="2"
                              style={{
                                verticalAlign: "middle",
                                textAlign: "center",
                              }}
                            >
                              Action
                            </th>
                          )}
                      </tr>
                      <tr>
                        <th scope="col">L</th>
                        <th scope="col">W</th>
                        <th scope="col">H</th>
                      </tr>
                    </thead>
                    <tbody>
                      {skidBreakdownListData &&
                      skidBreakdownListData.length > 0 ? (
                        <>
                          {(() => {
                            let i = 1; // Initialize a counter for the table rows
                            return skidBreakdownListData.map(
                              (inputField, index) =>
                                inputField.IsDeleted === false && (
                                  <Fragment
                                    key={`OrderSkidBreakdown_${inputField.SkidIndex}`}
                                  >
                                    <tr className="odd" role="row">
                                      <td>
                                        {inputField.IsDeleted === false
                                          ? i++
                                          : 0}
                                      </td>
                                      <td>
                                        <input
                                          type="text"
                                          className={`form-control  ${
                                            skidBreakdown.IsOrderSkidBreakdown ===
                                              true && "readonly_css "
                                          } ${
                                            submitted &&
                                            (!inputField.SkidWeight ||
                                              inputField.SkidWeight <= 0) &&
                                            "border-danger"
                                          }`}
                                          name="SkidWeight"
                                          value={inputField.SkidWeight}
                                          onChange={(e) =>
                                            handleSkidBreakdownChange(e, index)
                                          }
                                        />
                                      </td>
                                      <td>
                                        <input
                                          type="text"
                                          className={`form-control width-modify ${
                                            skidBreakdown.IsOrderSkidBreakdown ===
                                              true && "readonly_css "
                                          } ${
                                            submitted &&
                                            (!inputField.SkidDimensionLength ||
                                              inputField.SkidDimensionLength <=
                                                0) &&
                                            "border-danger"
                                          }`}
                                          name="SkidDimensionLength"
                                          value={inputField.SkidDimensionLength}
                                          onChange={(e) =>
                                            handleSkidBreakdownChange(e, index)
                                          }
                                        />
                                      </td>
                                      <td>
                                        <input
                                          type="text"
                                          className={`form-control width-modify  ${
                                            skidBreakdown.IsOrderSkidBreakdown ===
                                              true && "readonly_css "
                                          } ${
                                            submitted &&
                                            (!inputField.SkidDimensionWeight ||
                                              inputField.SkidDimensionWeight <=
                                                0) &&
                                            "border-danger"
                                          }`}
                                          name="SkidDimensionWeight"
                                          value={inputField.SkidDimensionWeight}
                                          onChange={(e) =>
                                            handleSkidBreakdownChange(e, index)
                                          }
                                        />
                                      </td>
                                      <td>
                                        <input
                                          type="text"
                                          className={`form-control width-modify ${
                                            skidBreakdown.IsOrderSkidBreakdown ===
                                              true && "readonly_css "
                                          } ${
                                            submitted &&
                                            (!inputField.SkidDimensionHeight ||
                                              inputField.SkidDimensionHeight <=
                                                0) &&
                                            "border-danger"
                                          }`}
                                          name="SkidDimensionHeight"
                                          value={inputField.SkidDimensionHeight}
                                          onChange={(e) =>
                                            handleSkidBreakdownChange(e, index)
                                          }
                                        />
                                      </td>
                                      <td>
                                        <input
                                          type="text"
                                          style={{ width: "50px" }}
                                          className={`form-control width-modify ${
                                            skidBreakdown.IsOrderSkidBreakdown ===
                                              true && "readonly_css "
                                          } ${
                                            submitted &&
                                            (!inputField.SkidBoxNumbers ||
                                              inputField.SkidBoxNumbers <= 0) &&
                                            "border-danger"
                                          }`}
                                          name="SkidBoxNumbers"
                                          value={inputField.SkidBoxNumbers}
                                          // onBlur={(e) => SkidHandleBlur(e, index)}
                                          onChange={(e) =>
                                            handleSkidBreakdownChange(e, index)
                                          }
                                          maxLength={4}
                                        />
                                      </td>

                                      <td className="new-width">
                                        <div>
                                          {
                                            <div className="">
                                              {inputField.ImageFilePath ||
                                              inputField.ImageBase64 ? (
                                                <img
                                                  style={{
                                                    height: "74px",
                                                    width: "100px",
                                                  }}
                                                  className="center-width-img"
                                                  src={
                                                    skidBreakdown.IsOrderSkidBreakdown ===
                                                    true
                                                      ? REACT_APP_API_IMAGE_URL +
                                                        inputField.ImageFilePath
                                                      : !inputField.ImageBase64
                                                      ? REACT_APP_API_IMAGE_URL +
                                                        inputField.ImageFilePath
                                                      : inputField.ImageBase64
                                                  }
                                                  alt="Card_image_cap"
                                                />
                                              ) : (
                                                <img
                                                  style={{
                                                    height: "74px",
                                                    width: "100px",
                                                  }}
                                                  className="center-width-img"
                                                  src={emptyImage}
                                                  alt="Card_image_cap"
                                                />
                                              )}
                                            </div>
                                          }
                                        </div>
                                        {skidBreakdown.IsOrderSkidBreakdown ===
                                          false && (
                                          <input
                                            type="file"
                                            className="custom-file-input form-control new-style-upload"
                                            name="ImageFilePath"
                                            accept="image/png, image/jpg, image/jpeg"
                                            onChange={(e) =>
                                              handleSkidFileChange(
                                                e,
                                                index,
                                                e.target.files[0]
                                              )
                                            }
                                          />
                                        )}
                                      </td>

                                      <td>
                                        {skidBreakdown &&
                                          skidBreakdown.IsOrderSkidBreakdown ===
                                            false && (
                                            <div className="d-flex">
                                              <div
                                                className="btn btn-danger shadow btn-xs sharp"
                                                onClick={(e) =>
                                                  handleDeleteSkid(
                                                    index,
                                                    inputField.OrderSkidBreakdownID
                                                  )
                                                }
                                                title="Delete"
                                              >
                                                <i className="fa fa-trash"></i>
                                              </div>
                                            </div>
                                          )}
                                      </td>
                                    </tr>
                                  </Fragment>
                                )
                            );
                          })()}

                          <tr>
                            <td className="text-start" colSpan={3}>
                              <h5>
                                <b>
                                  Total Skid Weight :{" "}
                                  {skidBreakdown.TotalSkidWeight}{" "}
                                </b>
                              </h5>
                            </td>
                          </tr>
                        </>
                      ) : (
                        <tr>
                          <td colSpan="11" className="norecordfound">
                            <span>No Records Found</span>
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="danger light"
            onClick={() => handleSkidBreakdownClosePopup()}
          >
            Cancel
          </Button>
          {skidBreakdown?.IsOrderSkidBreakdown === false && (
            <Button
              variant=""
              disabled={
                skidBreakdown.IsOrderSkidBreakdown || isdisabled ? true : false
              }
              onClick={(event) => handleSubmitSkid(event)}
              className="btn btn-primary"
            >
              Save
            </Button>
          )}
          {skidBreakdown?.IsOrderSkidBreakdown === true &&
            skidBreakdown?.IsOrderSkid === false &&
            (currentUser.UserTypeID === 1 || currentUser.UserTypeID === 2) && (
              <Button
                variant=""
                disabled={isdisabled ? true : false}
                onClick={(event) => handleRevokeSkid(event)}
                className="btn btn-primary"
              >
                Revoke Skid
              </Button>
            )}
        </Modal.Footer>
      </Modal>
      <Modal
        className="fade bd-example-modal-xl"
        show={isOrderReversedModal}
        size="xl"
      >
        <Modal.Header>
          <Modal.Title>
            Order Reversed - {orderCurrentRow?.current?.value?.OrderNumber}
          </Modal.Title>
          <Button
            variant=""
            className="btn-close"
            // onClick={() => setAllocationModal(false)}
            onClick={() => handleClosePopup()}
          ></Button>
        </Modal.Header>
        <Modal.Body>
          {orderDetail?.OrderProductModelList && (
            <RowSelectTable
              id={"reversedID"}
              columns={reversedColumns}
              data={orderDetail?.OrderProductModelList}
              onRowSelect={handleRowSelection}
            />
          )}
        </Modal.Body>

        <Modal.Footer>
          <Button variant="danger light" onClick={() => handleClosePopup()}>
            Cancel
          </Button>

          <Button
            variant=""
            // onClick={() => setLargeModal(false)}
            onClick={handleOrderReversed}
            className="btn btn-primary"
          >
            Reversed
          </Button>
        </Modal.Footer>
      </Modal>
      {loader}
    </>
  );
};

export default OrderList;
